const NAMESPACE = 'pmi';
const BUILD = /* pmi */ { hydratedSelectorName: "hydrated", lazyLoad: true, propChangeCallback: true, slotRelocation: true, updatable: true};

const globalScripts = () => {};
const globalStyles = "@charset \"UTF-8\";@font-face{font-family:\"FSAlbert\";src:url(\"https://docs.gcs.digitalpfizer.com/fonts/fs_albert_pro_web/Latin/Regular/FSAlbertWeb-Regular.woff\") format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:\"FSAlbert\";src:url(\"https://docs.gcs.digitalpfizer.com/fonts/fs_albert_pro_web/Latin/Bold/FSAlbertWeb-Bold.woff\") format(\"woff\");font-weight:700;font-style:normal;font-display:swap}@font-face{font-family:\"FSAlbert\";src:url(\"https://docs.gcs.digitalpfizer.com/fonts/fs_albert_pro_web/Latin/Italic/FSAlbertWeb-Italic.woff\") format(\"woff\");font-weight:400;font-style:italic;font-display:swap}@font-face{font-family:\"FSAlbert\";src:url(\"https://docs.gcs.digitalpfizer.com/fonts/fs_albert_pro_web/Latin/BoldItalic/FSAlbertWeb-BoldItalic.woff\") format(\"woff\");font-weight:700;font-style:italic;font-display:swap}[class^=icon-]:not(.far):before,[class*=\" icon-\"]:not(.far):before{font-family:\"fontello\";speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;letter-spacing:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-arrow-circle-left:before{content:\"\\e800\"}.icon-arrow-circle-right:before{content:\"\\e801\"}.icon-arrow-right:before{content:\"\\e802\"}.icon-phone:before{content:\"\\e803\"}.icon-chat:before{content:\"\\e804\"}.icon-email:before{content:\"\\e805\"}.icon-thumbs-up:before{content:\"\\e806\"}.icon-thumbs-down:before{content:\"\\e807\"}.icon-view:before{content:\"\\e808\"}.icon-download:before{content:\"\\e809\"}.icon-notification:before{content:\"\\e80a\"}.icon-resources:before{content:\"\\e80b\"}.icon-clinical-trials:before{content:\"\\e80c\"}.icon-patient-assist:before{content:\"\\e80d\"}.icon-search:before{content:\"\\e80e\"}.icon-url:before{content:\"\\e80f\"}.icon-arrow-circle-down:before{content:\"\\e810\"}.icon-medical-shield:before{content:\"\\e811\"}.icon-medical-snake:before{content:\"\\e812\"}.icon-stethoscope:before{content:\"\\e813\"}.icon-cog:before{content:\"\\e814\"}.icon-user:before{content:\"\\e815\"}.icon-screen-rotation:before{content:\"\\e816\"}.icon-fullscreen:before{content:\"\\e817\"}.icon-fullscreen-exit:before{content:\"\\e818\"}.icon-triangle-right:before{content:\"\\e819\"}.icon-triangle-down:before{content:\"\\e81a\"}.icon-plus:before{content:\"+\"}.icon-pdf{position:relative}.icon-pdf:before{content:\"\\e81b\"}.icon-pdf:after{font-family:\"fontello\";speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;letter-spacing:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\e81c\";position:absolute;left:0;top:-1px;color:red}.icon-minus:before{content:\"−\"}.icon-whats-app{font-weight:inherit;font-size:inherit;line-height:1.33;min-height:1.77em;display:flex;gap:3px;padding-top:3px}.icon-whats-app::before{vertical-align:middle;display:inline-block;width:1.77em;height:1.77em;margin-top:-3px;flex-shrink:0;content:\"\";background-size:auto 1.77em;background-position:center;background-image:url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 204.2 205.2'%3E%3Cpath fill='%23FEFEFE' d='M129.4,180.7c2.5-0.8,4.8-1.7,7.2-2.7c-10.5,4.2-21.7,6.2-33.2,6.5C112.1,184.5,120.8,183.1,129.4,180.7z'/%3E%3Cpath fill='%23FEFEFE' d='M29.4,138.7c-1.1-1.6-2.1-3.2-3-4.9c2,4.6,4.5,9.1,7.7,13.4c0,0,0,0,0,0c0-0.5-0.1-1.1-0.1-1.8 C31.8,141.9,31.8,141.9,29.4,138.7z'/%3E%3Cpath fill='%23FEFEFE' d='M33.9,154.7c-0.7,2.4-1.8,4.7-2.8,7.2c-0.8,2-1.6,4.1-2.3,6.1c-0.4,0.9-0.7,1.8-1.1,2.7 c-0.9,3-0.9,5.6-0.8,8.7c0.4-6.2,1.6-10.9,4-16.5C32.7,158.9,33.5,156.8,33.9,154.7z'/%3E%3Cpath fill='%23FEFEFE' d='M45.4,39.2c0.1-0.1,0.2-0.2,0.3-0.3C45.6,39,45.5,39.1,45.4,39.2z'/%3E%3Cpath fill='%23FEFEFE' d='M38.9,176.8c2.1-0.7,4.1-1.4,6.2-2.1c-1,0.3-2,0.7-3.1,1C41,176.1,40,176.4,38.9,176.8z'/%3E%3Cpath fill='%23FEFEFE' d='M20.3,85.9C23.6,68.1,32,52.5,44.5,40.1C31.9,52.2,23,68.6,20.3,85.9z'/%3E%3Cpath fill='%23FEFEFE' d='M123.9,17.9c-21.3-5.1-44-1.8-62.7,9.3C80.1,16.4,102.9,13.1,123.9,17.9z'/%3E%3Cpath fill='%23FEFEFE' d='M19.8,89.4c0,0.3-0.1,0.6-0.1,0.9c0,0.5,0,1.1-0.1,1.6C19.7,91,19.8,90.2,19.8,89.4z'/%3E%3Cpath fill='%23FEFEFE' d='M157,34.4c1.3,1,1.3,1,2.6,2.1c9.7,8.3,17.3,18.8,22.4,30.4c-8.1-19.3-23.8-35.2-42.8-43.9 c-0.3-0.1-0.6-0.2-0.8-0.3c5.7,2.5,11.1,5.7,16.1,9.6C155.7,33.3,155.7,33.3,157,34.4z'/%3E%3Cpath fill='%23FEFEFE' d='M55.7,171.6c0.9,0,1.7,0.1,2.9,0.3C57.5,171.5,56.7,171.4,55.7,171.6z'/%3E%3Cpath fill='%23FEFEFE' d='M188.2,101.2c-0.3,23-9.3,42.5-24.7,58.9c15-14.6,23.9-34.9,24.7-55.8c0-2.2,0.1-4.4,0-6.6c0,0.2,0,0.3,0,0.5 C188.2,99.2,188.2,100.2,188.2,101.2z'/%3E%3Cpath fill='%2313990A' d='M26.3,133.7c0.9,1.7,1.9,3.4,3,4.9c2.4,3.3,2.4,3.3,4.5,6.7c0.1,0.6,0.1,1.2,0.1,1.8c0.8,2.7,0.6,5.1,0,7.6 c-0.4,2-1.3,4.2-3,8.1c-2.4,5.7-3.6,10.4-4,16.5c4.1-0.4,8.1-1.4,11.9-2.6c1-0.4,2.1-0.7,3.1-1.1c1-0.3,2.1-0.7,3.1-1 c1-0.3,1.9-0.7,2.9-1c4.4-1.5,6.1-2,7.7-2.1c1-0.1,1.9,0,2.9,0.3c0.3,0,0.5,0.1,0.8,0.1c1.3,0.7,1.3,0.7,2.7,1.4 c0.9,0.5,1.8,0.9,2.7,1.4c0.9,0.5,1.8,1,2.8,1.5c11.4,5.8,23.6,8.3,35.9,8.3c11.5-0.3,22.7-2.3,33.2-6.5 c8.6-3.6,16.3-8.3,23.4-14.7c0.8-0.7,1.7-1.5,2.5-2.2c0.3-0.3,0.7-0.7,1-1c15.4-16.4,24.3-35.9,24.7-58.9c0-1,0-2,0-3 c0-0.2,0-0.3,0-0.5c-0.2-8.7-1.2-16.8-4.3-25.4c-0.4-1-0.7-2.1-1.1-3.2c-0.3-0.8-0.6-1.6-1-2.3c-5-11.6-12.6-22.1-22.4-30.4 c-1.3-1.1-1.3-1.1-2.6-2.1c-1.3-1.1-1.3-1.1-2.6-2.1c-5-3.9-10.4-7.1-16.1-9.6c-2.1-0.8-4.2-1.6-6.3-2.3c-1.2-0.4-2.3-0.8-3.6-1.2 c-1.5-0.4-3-0.8-4.5-1.2c-21-4.9-43.8-1.5-62.7,9.3c-3.6,2.1-7,4.5-10.2,7.2c-0.9,0.7-1.7,1.4-2.6,2.1c-0.9,0.8-1.9,1.6-2.8,2.5 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.6-0.9,0.9C32,52.5,23.6,68.1,20.3,85.9c-0.2,1.2-0.3,2.3-0.5,3.5 c-0.1,0.8-0.1,1.6-0.2,2.5C19,106.5,20.6,120.7,26.3,133.7z M56,69.4c3.9-10.8,10.6-16.2,22-15c3.7,3.7,5.2,7.6,7.2,12.3 c0.6,1.3,0.6,1.3,1.1,2.6c3.5,8.4,3.5,8.4,2.7,13.1c-1.7,2.5-3.5,4.5-5.6,6.8c-1.6,2.1-1.6,2.1-1.4,4.6c5.1,13.5,18,22.4,30.2,28.7 c3.2,1.1,4.6,1.2,7.8-0.1c2.6-2.5,2.6-2.5,4.8-5.6c0.8-1,1.6-2,2.4-3.1c0.6-0.8,1.2-1.6,1.8-2.4c6.1,0.5,11,3.3,16.4,6.1 c0.9,0.5,1.9,0.9,2.8,1.4c2.3,1.2,4.5,2.3,6.8,3.5c0.1,6.9-0.1,11.1-4,17c-6.5,5.4-13,8.6-21.6,8.4c-23.4-3-43.3-17.2-57.8-35 c-4.2-5.6-8-11.4-11.6-17.4c-0.5-0.8-1-1.5-1.4-2.3C54.6,85.9,55,77.3,56,69.4z'/%3E%3Cpath fill='%23F5F6F5' d='M4.2,204.8c0.9-0.3,1.9-0.6,2.8-0.9c1.1-0.4,2.1-0.7,3.1-1.1c2.3-0.8,4.6-1.6,6.9-2.3 c3.7-1.2,7.4-2.5,11.1-3.7c3.7-1.3,7.4-2.5,11.1-3.8c1.2-0.4,2.4-0.8,3.5-1.2c5.8-2,10.2-4.1,16.3-2.3c14.2,8.7,32.2,11.5,48.6,11 c28.6-1.9,53.8-13.8,72.8-35.3c19.2-23.3,25.6-49.8,23.2-79.4c-3.9-27.2-18.8-50.2-40.3-66.7C122.6-10.4,65.7-5.3,30.9,31.2 c-1,1.1-1.9,2.1-2.9,3.2c-7.7,8.4-13,18-17.5,28.5c-9.8,26-9.1,53.7,2.2,79.1c0.6,1.3,1.2,2.6,1.8,3.9c1.7,3.9,3.2,6.7,1.6,10.8 c-1.3,3.1-1.3,3.1-3.6,10.1c-0.5,1.5-0.5,1.5-1,2.9c-1,3.1-2.1,6.2-3.1,9.3c-0.7,2.1-1.4,4.3-2.1,6.4c-2.1,6.3-4.2,12.6-6.3,19 C2,205.4,2,205.4,4.2,204.8z M19.8,89.4c0.1-1.2,0.3-2.3,0.5-3.5C23,68.6,31.9,52.2,44.5,40.1c0.3-0.3,0.6-0.6,0.9-0.9 c0.1-0.1,0.2-0.2,0.3-0.3c0.9-0.8,1.8-1.7,2.8-2.5c0.9-0.7,1.7-1.4,2.6-2.1c3.2-2.7,6.6-5.1,10.2-7.2c18.7-11.1,41.4-14.4,62.7-9.3 c1.5,0.4,3,0.8,4.5,1.2c1.2,0.4,2.4,0.8,3.6,1.2c2.1,0.7,4.2,1.5,6.3,2.3c0.3,0.1,0.6,0.2,0.8,0.3c19,8.7,34.7,24.5,42.8,43.9 c0.3,0.8,0.7,1.5,1,2.3c0.4,1.1,0.7,2.1,1.1,3.2c3.1,8.6,4.1,16.7,4.3,25.4c0,2.1,0,4.3,0,6.6c-0.8,21-9.6,41.2-24.7,55.8 c-0.3,0.3-0.7,0.7-1,1c-0.9,0.8-1.7,1.5-2.5,2.2c-7,6.4-14.8,11.1-23.4,14.7c-2.3,1-4.7,1.9-7.2,2.7c-8.6,2.4-17.3,3.8-26,3.8 c-12.3,0.1-24.5-2.4-35.9-8.3c-0.9-0.5-1.9-1-2.8-1.5c-0.9-0.5-1.8-0.9-2.7-1.4c-1.3-0.7-1.3-0.7-2.7-1.4c-0.3-0.1-0.6-0.1-0.8-0.1 c-1.2-0.2-2-0.3-2.9-0.3c-1.6,0.1-3.3,0.6-7.7,2.1c-1,0.3-1.9,0.7-2.9,1c-2.1,0.7-4.1,1.4-6.2,2.1c-3.9,1.2-7.8,2.2-11.9,2.6 c-0.1-3.1-0.1-5.7,0.8-8.7c0.4-0.9,0.7-1.8,1.1-2.7c0.8-2,1.5-4.1,2.3-6.1c1-2.5,2.1-4.8,2.8-7.2c0.7-2.4,0.9-4.8,0-7.6 c0,0,0,0,0,0c-3.1-4.3-5.6-8.8-7.7-13.4c-5.7-13.1-7.3-27.2-6.7-41.9c0-0.5,0-1.1,0.1-1.6C19.8,90,19.8,89.7,19.8,89.4z'/%3E%3Cpath fill='%23F4F5F4' d='M60,95.4c3.6,6,7.3,11.8,11.6,17.4c14.5,17.8,34.5,32,57.8,35c8.6,0.2,15.1-3,21.6-8.4c3.9-5.9,4.1-10.1,4-17 c-2.3-1.2-4.5-2.3-6.8-3.5c-1-0.5-1.9-1-2.8-1.4c-5.4-2.8-10.2-5.6-16.4-6.1c-0.6,0.8-1.2,1.6-1.8,2.4c-0.8,1-1.6,2.1-2.4,3.1 c-2.3,3.1-2.3,3.1-4.8,5.6c-3.2,1.3-4.5,1.2-7.8,0.1C100,116.2,87.1,107.3,82,93.8c-0.2-2.5-0.2-2.5,1.4-4.6c2-2.2,3.9-4.2,5.6-6.8 c0.8-4.8,0.8-4.8-2.7-13.1c-0.6-1.3-0.6-1.3-1.1-2.6c-2-4.7-3.5-8.7-7.2-12.3c-11.4-1.2-18.1,4.2-22,15c-1,7.9-1.4,16.5,2.6,23.7 C59,93.9,59.5,94.6,60,95.4z'/%3E%3C/svg%3E%0A\")}.icon-whats-app::after{top:0.4em !important}.icon-touch-finger:hover::before{background-color:#64cbed}.icon-touch-finger::before{content:\"\";display:inline-block;width:1.1em;height:1.1em;-webkit-mask:url(../../../src/assets/images/touch_finger_icon_second.svg) no-repeat center center;mask:url(../../../src/assets/images/touch_finger_icon_second.svg) no-repeat center center;-webkit-mask-size:contain;mask-size:contain;background-color:#006da3;transform:translateY(-10%)}.icon-dropdown-after::after{content:\"\";width:12px;height:8px;-webkit-mask:url(../../../src/assets/images/dropdown-icon.svg) no-repeat center center;mask:url(../../../src/assets/images/dropdown-icon.svg) no-repeat center center;-webkit-mask-size:contain;mask-size:contain;background-color:#64cbed}.pmi-jp-bot-icon-background{background-image:url(../../../src/assets/images/jp_chat.svg)}.container{display:flex;flex-direction:column;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}[data-gjs-type=wrapper] .container{display:block}@media (min-width: 768px){.container{width:750px}}@media (min-width: 992px){.container{width:970px}}@media (min-width: 1200px){.container{width:1130px}}.container>.custom-block-element{flex:1}.container-inner--center{max-width:600px;margin:0 auto}.container-inner--left{width:100%}@media (min-width: 992px){.container-inner--left{width:70%;padding-right:120px}}.container-narrow{max-width:600px;margin:0 auto}.container-narrow--default-width{margin-left:auto;margin-right:auto}@media (min-width: 768px){.container-narrow--default-width{margin-left:-60px;margin-right:-60px}}@media (min-width: 992px){.container-narrow--default-width{margin-left:-170px;margin-right:-170px}}@media (min-width: 1200px){.container-narrow--default-width{margin-left:-250px;margin-right:-250px}}p,.p{margin-bottom:13px}strong{font-weight:bold}.hide{display:none !important}.visible-xs{display:none !important}@media (max-width: 576px){.visible-xs{display:block !important}}@media (max-width: 576px){.hidden-xs{display:none !important}}.hidden-from-xs{display:none !important}.hide.visible-from-xs,.visible-from-xs{display:none !important;display:block !important}@media (max-width: 575.98px){.hidden-to-xs{display:none !important}}@media (max-width: 575.98px){.hide.visible-to-xs,.visible-to-xs{display:block !important}}.hide{display:none !important}.visible-sm{display:none !important}@media (min-width: 576px) and (max-width: 768px){.visible-sm{display:block !important}}@media (min-width: 576px) and (max-width: 768px){.hidden-sm{display:none !important}}@media (min-width: 576px){.hidden-from-sm{display:none !important}}.hide.visible-from-sm,.visible-from-sm{display:none !important}@media (min-width: 576px){.hide.visible-from-sm,.visible-from-sm{display:block !important}}@media (max-width: 767.98px){.hidden-to-sm{display:none !important}}@media (max-width: 767.98px){.hide.visible-to-sm,.visible-to-sm{display:block !important}}.hide{display:none !important}.visible-md{display:none !important}@media (min-width: 768px) and (max-width: 992px){.visible-md{display:block !important}}@media (min-width: 768px) and (max-width: 992px){.hidden-md{display:none !important}}@media (min-width: 768px){.hidden-from-md{display:none !important}}.hide.visible-from-md,.visible-from-md{display:none !important}@media (min-width: 768px){.hide.visible-from-md,.visible-from-md{display:block !important}}@media (max-width: 991.98px){.hidden-to-md{display:none !important}}@media (max-width: 991.98px){.hide.visible-to-md,.visible-to-md{display:block !important}}.hide{display:none !important}.visible-lg{display:none !important}@media (min-width: 992px) and (max-width: 1200px){.visible-lg{display:block !important}}@media (min-width: 992px) and (max-width: 1200px){.hidden-lg{display:none !important}}@media (min-width: 992px){.hidden-from-lg{display:none !important}}.hide.visible-from-lg,.visible-from-lg{display:none !important}@media (min-width: 992px){.hide.visible-from-lg,.visible-from-lg{display:block !important}}@media (max-width: 1199.98px){.hidden-to-lg{display:none !important}}@media (max-width: 1199.98px){.hide.visible-to-lg,.visible-to-lg{display:block !important}}.hide{display:none !important}.visible-xl{display:none !important}@media (min-width: 1200px) and (max-width: 1250px){.visible-xl{display:block !important}}@media (min-width: 1200px) and (max-width: 1250px){.hidden-xl{display:none !important}}@media (min-width: 1200px){.hidden-from-xl{display:none !important}}.hide.visible-from-xl,.visible-from-xl{display:none !important}@media (min-width: 1200px){.hide.visible-from-xl,.visible-from-xl{display:block !important}}@media (max-width: 1249.98px){.hidden-to-xl{display:none !important}}@media (max-width: 1249.98px){.hide.visible-to-xl,.visible-to-xl{display:block !important}}.hide{display:none !important}.visible-xxl{display:none !important}@media (min-width: 1250px){.visible-xxl{display:block !important}}@media (min-width: 1250px){.hidden-xxl{display:none !important}}@media (min-width: 1250px){.hidden-from-xxl{display:none !important}}.hide.visible-from-xxl,.visible-from-xxl{display:none !important}@media (min-width: 1250px){.hide.visible-from-xxl,.visible-from-xxl{display:block !important}}.hidden-to-xxl{display:none !important}.hide.visible-to-xxl,.visible-to-xxl{display:block !important}[data-gjs-type=wrapper] .insert-here:empty{width:100%}[data-gjs-type=wrapper] .insert-here:empty::after{min-height:300px;height:auto;width:100%;content:\"Insert content here\";outline:2px dashed #000;background:#bfbfbf;display:grid;place-items:center;transition:0.25s all ease-in;color:#404040}[data-gjs-type=wrapper] .insert-here:empty.container::after{content:\"Insert default container content here\"}[data-gjs-type=wrapper] .insert-here:empty.container-inner--left::after{content:\"Insert left narrow container content here\"}[data-gjs-type=wrapper] .insert-here:empty.container-inner--center::after{content:\"Insert center narrow container content here\"}[data-gjs-type=wrapper] .insert-here:empty.text-header::after{content:\"Insert header here\"}[data-gjs-type=wrapper] .insert-here:empty.anonymous::after{content:\"Insert anonymous content here\"}[data-gjs-type=wrapper] .insert-here:empty.hcp::after{content:\"Insert HCP content (hidden) here\"}[data-gjs-type=wrapper] .insert-here:empty.patient::after{content:\"Insert patient content (hidden) here\"}[data-gjs-type=wrapper] .insert-here:empty.overlay::after{content:\"Insert content behind overlay for anonymous here\"}[data-gjs-type=wrapper] .insert-here:empty.text-footer::after{content:\"Insert footer here\"}sup{font-size:47%;top:-0.8em;line-height:0;position:relative;vertical-align:baseline;}sup sup{top:0;font-size:inherit}a:focus{color:#006da3}.div{display:block}img{max-width:100%;height:auto;display:block}.page-title{border-style:none;padding:0;margin:0 0 40px}.page-subtitle{display:block;font-size:26px;letter-spacing:0;color:#666}.page-header--bg-dark{color:#fff;background-color:#001d39}table{margin-bottom:20px}table th,table td{border:1px solid #ddd;padding:8px 15px}table th{background:#f0f0f0}table.no-borders th,table.no-borders td{border-style:none !important}.footnote{font-size:70%}.bg-blue{background:#006da3}.bg-blue-dark{background:#001d39}.bg-blue-light{background:#64cbed}.bg-blue-lighter{background:#c5ecf9}.bg-brown{background:#b85600}.bg-purple{background:#371c49}.bg-blue-gradient{background:#001d39;background:linear-gradient(90deg, #001d39 0%, #005583 100%)}.bg-red{background:#ff0000}.bg-green{background:#6ea831}.color-red{color:#ff0000}.color-black{color:#000}.color-brown{color:#b85600}.color-blue{color:#006da3}.color-inherit{color:inherit}.custom-block-is-swe-no{position:relative;z-index:1;width:100%}@media (min-width: 768px){.mshow{display:none !important}}@media (max-width: 767.98px){.mhide{display:none !important}}.make-container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;max-width:100%}@media (min-width: 768px){.make-container{width:750px}}@media (min-width: 992px){.make-container{width:970px}}@media (min-width: 1200px){.make-container{width:1130px}}.p-b-default{padding-top:27px;padding-bottom:50px}@media (min-width: 768px){.p-b-default{padding-top:0;padding-bottom:70px}}@media (min-width: 992px){.find-container{display:flex}}.find-container .find-container__left{border-bottom:1px solid #ddd;padding-bottom:43px;margin-bottom:47px}@media (min-width: 768px){.find-container .find-container__left{border-width:5px;padding-bottom:43px;margin-bottom:46px}}@media (min-width: 992px){.find-container .find-container__left{width:60%;border-bottom-style:none;border-right:5px solid #eee;padding-bottom:0;margin-bottom:0;padding-right:70px}}.find-container .find-container__left h1+pmi-search-block-v2{margin-top:0}@media (min-width: 768px){.find-container .find-container__left h1+pmi-search-block-v2{margin-top:-20px}}.find-container .find-container__left pmi-search-block-v2{max-width:100%}@media (min-width: 992px){.find-container .find-container__left pmi-search-block-v2{max-width:528px}}.find-container--without-separator .find-container__left{border:0;padding:0}.find-container h1,.find-container h2{font-size:40px}@media (min-width: 768px){.find-container h1,.find-container h2{font-size:44px}}.find-container h1{margin:0 0 40px}.find-container h2{margin-top:0;margin-bottom:15px}@media (min-width: 768px){.find-container h2{margin-bottom:5px}}.find-container h3{color:#666;margin-top:5px;margin-bottom:17px;font-size:18px;line-height:1.445}@media (min-width: 768px){.find-container h3{margin-bottom:32px}}.find-container h3 br{display:block;margin:0 0 13px;content:\" \";line-height:13px}.find-container h3 span{margin-bottom:13px;display:inline-block}.find-container .find-container__right{padding-left:0;width:100%}@media (min-width: 992px){.find-container .find-container__right{padding-left:70px;width:40%}}.find-container .find-container__right h2+pmi-quick-finder,.find-container .find-container__right h2+pmi-quick-finder-dynamic{margin-top:17px}@media (min-width: 768px){.find-container .find-container__right h2+pmi-quick-finder,.find-container .find-container__right h2+pmi-quick-finder-dynamic{margin-top:32px}}.visually-hidden{position:absolute !important;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);width:1px;height:1px;word-wrap:normal;margin:0 !important;padding:0 !important}.content-with-lines-before-after{display:flex;align-items:center;gap:50px}.content-with-lines-before-after:before,.content-with-lines-before-after:after{content:\"\";display:block;width:auto;height:1px;background-color:#ddd;flex-grow:1}.fi.fi-hk{filter:brightness(1.3)}.pmi-triangle-symbol{color:#000 !important}.pmi-table-responsive-wrapper{width:100%;overflow-x:auto}pmi-nav-header:not(.hydrated){display:block;position:relative;background:linear-gradient(90deg, #001d39 0%, #005583 100%);padding:0 !important;margin:0;height:131px;width:100% !important}@media (min-width: 992px){pmi-nav-header:not(.hydrated){height:155px}}pmi-banner:not(.hydrated){background:var(--pmi-blue-dark);display:block;height:250px}pmi-nav-footer:not(.hydrated){display:block;width:100% !important;height:184px;background:#001d39;background:linear-gradient(90deg, #001d39 0%, #005583 100%)}pmi-gate:not(.hydrated){display:block;height:482px}pmi-grv-block:not(.hydrated){display:none}input::placeholder{color:#737373;opacity:1;}#_evidon-barrier-wrapper,body>[id^=_evidon],body>[id^=evidon-]{z-index:1000 !important}.pmi-text-align-left{text-align:left}.pmi-text-align-center{text-align:center}.pmi-text-align-right{text-align:right}h1,.h1,h2,.h2,h3,.h3,h4,.h4,h5,.h5,h6,.h6{color:#001d39}h1,.h1{font-size:40px;font-weight:400;line-height:1;letter-spacing:-1px;margin-top:26px;margin-bottom:13px}@media (min-width: 768px){h1,.h1{font-size:44px}}h2,.h2{font-size:40px;font-weight:400;line-height:1;letter-spacing:-1px;margin-top:26px;margin-bottom:13px}h3,.h3{font-size:30px;font-weight:400;line-height:1;letter-spacing:-0.5px;margin-top:26px;margin-bottom:13px}h4,.h4{font-size:26px;font-weight:700;line-height:1;letter-spacing:normal;margin-top:13px;margin-bottom:13px}h5,.h5{font-size:18px;font-weight:400;line-height:1;margin-top:13px;margin-bottom:13px}h6,.h6{font-size:16px;font-weight:400;line-height:1;margin-top:13px;margin-bottom:13px}ul,ol{margin-top:0;margin-bottom:13px;padding-left:27px}ul li,ol li{margin-bottom:10px}button{background:transparent;border:0;box-shadow:none;padding:0;font-family:var(--pmi-font-family)}a{text-decoration:none;color:#006da3}a:hover{color:#64cbed}a:not(.exclude-external-link-icon):not(.exclude-block-external-link-icon a)[href^=\"http:\"]::after,a:not(.exclude-external-link-icon):not(.exclude-block-external-link-icon a)[href^=\"https:\"]::after,a:not(.exclude-external-link-icon):not(.exclude-block-external-link-icon a)[href^=\"www.\"]::after{font-family:\"fontello\";speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;letter-spacing:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\e80f\";font-size:0.75em;position:relative;top:-0.15em;padding-left:0.5em}.prescribing-information-link{display:inline-block;color:#006da3;font-weight:bold;font-size:18px;text-decoration:none}.prescribing-information-link:hover{color:#64cbed}.prescribing-information-link::before{font-size:25px;margin-right:15px}.btn{display:inline-block;font-weight:700;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;font-size:20px;padding:3px 25px;color:#001d39;background-color:#64cbed;border:0 none;line-height:1.445;border-radius:8px;margin:0}.btn--no-focus-border:focus{border-style:none}.btn:hover,.btn:focus{color:#fff;background-color:#006da3;text-decoration:none}.btn:hover{outline:0}.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn[disabled],fieldset[disabled] .btn{cursor:default;opacity:0.65}.btna.disabled,fieldset[disabled] .btna{pointer-events:none}.btn-continue{color:white;background-color:#006da3;letter-spacing:-0.4px;padding:5px 22px}.btn-continue:hover{background-color:#64cbed}.btn-continue:focus{outline:1px solid #64cbed;outline-offset:-2px}.btn-cancel{color:#006da3;background-color:#fff;border:3px solid #006da3;letter-spacing:-0.4px;padding:3px 20px}.btn-cancel:hover{background-color:#fff;border-color:#64cbed;color:#64cbed}.btn-cancel:focus{color:#006da3;background-color:#fff;border:3px solid #006da3;outline:1px solid #64cbed;outline-offset:-2px}.btn-link{font-size:14px;padding:5px 10px;color:#006da3;background-color:#fff;border:2px solid #006da3;line-height:1.445;border-radius:8px;cursor:pointer;text-align:center;text-decoration:none;font-weight:700}.btn-link:hover{color:#64cbed;background-color:#fff;border-color:#64cbed}@media (min-width: 768px){.btn-link{font-size:14px;padding:5px 10px}}@media (min-width: 1200px){.btn-link{font-size:16px;padding:6px 18px}}.btn-link-default{background:none;box-shadow:none;cursor:pointer;padding:0;border:0;display:inline;font-size:inherit;border-radius:0;text-decoration:none;color:#006da3}.btn-link-default:hover,.btn-link-default:focus{color:#64cbed}.btn-link-default:hover,.btn-link-default:focus{outline-offset:4px;background-color:transparent}.btn-link-default--light{font-weight:400}.btn-menu{cursor:pointer;padding:0;background-color:transparent;border-style:none;color:#fff;font-family:var(--pmi-font-family);font-size:16px;font-weight:700;vertical-align:baseline}.btn-menu:hover,.btn-menu:focus{color:#64cbed;background-color:transparent}.btn-primary:hover{background-color:#64cbed;border-color:#64cbed}.btn-primary:focus{background-color:#006da3;border-color:#006da3}.btn-primary:active{background-color:#64cbed;border-color:#64cbed}.btn-primary:active:hover,.btn-primary:active:focus{background-color:#64cbed;border-color:#64cbed}.btn-secondary{color:#001d39;background-color:#64cbed;border-color:#64cbed}.btn-secondary:hover{color:#fff;background-color:#006da3;border-color:#006da3}.btn-secondary:focus{color:#001d39}.btn-info{font-weight:700}.btn-info:hover{color:#64cbed;background-color:#fff;border-color:#64cbed}.btn-info:focus{color:#006da3;background-color:#fff;border-color:#006da3}.btn-info:active{color:#64cbed;background-color:#fff;border-color:#64cbed}.btn-info:active:hover,.btn-info:active:focus{color:#64cbed;background-color:#fff;border-color:#64cbed}.btn-filter{color:#006da3;background-color:#fff;padding:3px 20px;font-weight:400;border-radius:8px}.btn-filter:hover,.btn-filter:focus{color:#fff;background-color:#006da3}.btn-filter--active{color:#fff;background-color:#006da3}.btn-arrow{display:block;position:relative;font-size:18px;line-height:1.445;color:#006da3;font-weight:700}.btn-arrow::after{font-family:\"fontello\";speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;letter-spacing:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\" \\e801\";font-size:16px;margin-left:5px}.btn-arrow:hover{color:#64cbed}.btn-arrow-light{display:block;position:relative;font-size:18px;line-height:1.445;color:#64cbed;font-weight:700}.btn-arrow-light::after{font-family:\"fontello\";speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;letter-spacing:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\" \\e801\";font-size:16px;margin-left:5px}.btn-arrow-light:hover{color:#006da3}.btn-arrow-light:focus{color:#64cbed}.btn--close{position:relative;border:none;border-radius:0;background:#fff;width:32px;height:32px;line-height:32px;padding:0;display:flex;align-items:center;justify-content:center;font-weight:bold;color:#006da3;text-indent:0}.btn--close:hover,.btn--close:focus{background-color:#eee;text-decoration:none}.btn--close:before,.btn--close:after{position:absolute;content:\" \";height:20px;width:2px;background-color:#006da3}.btn--close:before{transform:rotate(45deg)}.btn--close:after{transform:rotate(-45deg)}.btn--close-text{position:absolute !important;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);width:1px;height:1px;word-wrap:normal;white-space:nowrap;clip-path:inset(50%)}.btn--inherit{background:none;box-shadow:none;cursor:pointer;padding:0;border:0;display:inline;font-size:inherit;border-radius:0}.btn--inherit:hover,.btn--inherit:focus{color:inherit;outline-offset:4px;background-color:transparent}:root{--pmi-white:rgba(255, 255, 255, 1);--pmi-black:rgba(0, 0, 0, 1);--pmi-blue:#006da3;--pmi-blue-l:#0093d0;--pmi-blue-dark:#001d39;--pmi-blue-light:#64cbed;--pmi-blue-lighter:#c5ecf9;--pmi-brown:#b85600;--pmi-brown-light:#ffa129;--pmi-purple:#371c49;--pmi-green:#6ea831;--pmi-blue-active:#004c72;--pmi-grey-base:#f0f0f0;--pmi-grey:#eee;--pmi-grey-darker:#666;--pmi-grey-dark:#ddd;--pmi-grey-silver:#ccc;--pmi-grey-light:#f5f5f5;--pmi-grey-lighter:#f9f9f9;--pmi-red:#ff0000;--pmi-text-color:#333;--pmi-font-family:\"FSAlbert\", Arial, Helvetica, sans-serif}#external-link-modal .modal[role=dialog]{background:rgba(0, 29, 57, 0.965);z-index:9010}#external-link-modal .modal .modal-dialog{margin:0;position:absolute;left:50%;top:50%;display:flex;transform:translate(-50%, -50%);max-width:768px;max-height:calc(100% - 60px);width:calc(100vw - 40px);border-style:none}#external-link-modal .modal .modal-content{border-radius:3px;padding:25px;justify-content:flex-end}@media (min-width: 768px){#external-link-modal .modal .modal-content{padding:50px}}#external-link-modal .modal .modal-header{border-style:none;display:block;padding:0}#external-link-modal .modal .close{display:none}#external-link-modal .modal .modal-title{font-family:var(--pmi-font-family);color:#001d39;font-size:30px;letter-spacing:-0.5px;font-weight:700;margin:0 0 25px;word-break:break-word;line-height:1}#external-link-modal .modal .modal-title:empty{display:none}#external-link-modal .modal .modal-body{padding:0;font-size:18px;line-height:1.445;margin-bottom:23px;word-break:break-word;overflow-y:auto}#external-link-modal .modal .modal-body:empty{display:none}#external-link-modal .modal .modal-body__link-title{color:#b85600;word-break:break-word}#external-link-modal .modal .modal-footer{display:flex;flex-direction:column;gap:17px;padding:0;margin:0;border-style:none}@media (min-width: 768px){#external-link-modal .modal .modal-footer{flex-direction:row;flex-wrap:wrap;justify-content:flex-start}}#external-link-modal .modal .modal-footer .btn{font-size:20px;border-width:2px;padding:3px 20px;line-height:1.445;letter-spacing:0;border-radius:8px;transition:none;font-weight:700;margin:0;width:100%}@media (min-width: 768px){#external-link-modal .modal .modal-footer .btn{width:auto}}#external-link-modal .modal .modal-footer .btn:focus{outline:2px solid #004c72}#external-link-modal .modal .btn-primary{color:#fff;background-color:#006da3;border-color:#006da3}#external-link-modal .modal .btn-primary:hover{background-color:#64cbed;border-color:#64cbed}#external-link-modal .modal .btn-secondary{color:#006da3;background-color:#fff;border-color:#006da3}#external-link-modal .modal .btn-secondary:hover{background-color:#fff;color:#64cbed;border-color:#64cbed}*{box-sizing:border-box}:root{--helix-core-spacing-multiplier:4px;--pmi-font-family-inter:\"Inter\", \"FSAlbert\", Arial, Helvetica, sans-serif;--pmi-font-noto-sans:\"noto_sansregular\", \"FSAlbert\", Arial, Helvetica, sans-serif;font-family:var(--pmi-font-family);color:var(--pmi-text-color);font-size:18px;line-height:1.445}html.pmi-custom-font--open-sans{--pmi-font-family:\"Open Sans\", sans-serif}html.pmi-custom-font--malgun-gothic{--pmi-font-family:\"Malgun Gothic\", Gulim, Tahoma, Verdana, Arial, sans-serif}html.pmi-custom-font--japan{--pmi-font-family:メイリオ, Meiryo, Osaka, \"ＭＳ Ｐゴシック\", Arial, Helvetica, sans-serif}.not-hydrated{visibility:hidden !important}html{height:100%}body{margin:0;font-size:18px;line-height:1.445;max-width:100%;width:100%;height:100%;display:flex;flex-direction:column}html body>div[data-swe-block-title=Footer]{display:block;margin-top:auto}body>helix-extras-isi-controller{display:flex;flex-direction:column;height:100%}body>helix-extras-isi-controller div[data-swe-block-title=Footer]{margin-top:auto}@media print{body .pmi-print-hidden{display:none}}p,.p{margin-top:0;margin-bottom:13px}a{color:var(--pmi-blue);text-decoration:none}a:hover{color:var(--pmi-blue-light)}button{background:none;box-shadow:none;cursor:pointer;padding:0;border:0}#_evh-link{background:var(--pmi-grey-base) !important;border:1px solid var(--pmi-grey-silver) !important;color:var(--pmi-blue) !important;bottom:4px !important;font-size:16px !important;font-weight:700 !important;line-height:1.3 !important;padding:6px 12px !important;text-decoration:none !important;right:0;min-width:100px;text-align:center;z-index:956 !important}@media (min-width: 992px){#_evh-link{right:20px !important}}#_evh-link:hover{background:var(--pmi-grey-dark) !important}.custom-block-element.custom-block-is-swe-yes:empty{display:none}[data-gjs-type=wrapper] .custom-block-element.custom-block-is-swe-yes:empty,[data-gjs-type=wrapper] .custom-block-element.custom-block-is-swe-yes:has(*:empty){display:block;width:100%;background-color:#eee}[data-gjs-type=wrapper] .custom-block-element.custom-block-is-swe-yes:empty::before,[data-gjs-type=wrapper] .custom-block-element.custom-block-is-swe-yes:has(*:empty)::before{min-height:100px;height:auto;width:calc(100% - 4px);content:\"Empty SWE block\";border:2px dashed #666;background:#eee;display:grid;place-items:center;transition:0.25s all ease-in;color:#000}[data-gjs-type=wrapper] .custom-block-element.custom-block-is-swe-yes:has(*:not(:empty)){width:auto;background-color:transparent}[data-gjs-type=wrapper] .custom-block-element.custom-block-is-swe-yes:has(*:not(:empty))::before{display:none}";

/*
 Stencil Client Platform v4.38.0 | MIT Licensed | https://stenciljs.com
 */
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/utils/constants.ts
var SVG_NS = "http://www.w3.org/2000/svg";
var HTML_NS = "http://www.w3.org/1999/xhtml";

// src/client/client-host-ref.ts
var getHostRef = (ref) => {
  if (ref.__stencil__getHostRef) {
    return ref.__stencil__getHostRef();
  }
  return void 0;
};
var registerInstance = (lazyInstance, hostRef) => {
  if (!hostRef) return;
  lazyInstance.__stencil__getHostRef = () => hostRef;
  hostRef.$lazyInstance$ = lazyInstance;
};
var registerHost = (hostElement, cmpMeta) => {
  const hostRef = {
    $flags$: 0,
    $hostElement$: hostElement,
    $cmpMeta$: cmpMeta,
    $instanceValues$: /* @__PURE__ */ new Map(),
    $serializerValues$: /* @__PURE__ */ new Map()
  };
  {
    hostRef.$onInstancePromise$ = new Promise((r) => hostRef.$onInstanceResolve$ = r);
  }
  {
    hostRef.$onReadyPromise$ = new Promise((r) => hostRef.$onReadyResolve$ = r);
    hostElement["s-p"] = [];
    hostElement["s-rc"] = [];
  }
  {
    hostRef.$fetchedCbList$ = [];
  }
  const ref = hostRef;
  hostElement.__stencil__getHostRef = () => ref;
  return ref;
};
var isMemberInElement = (elm, memberName) => memberName in elm;
var consoleError = (e, el) => (0, console.error)(e, el);

// src/client/client-load-module.ts
var cmpModules = /* @__PURE__ */ new Map();
var loadModule = (cmpMeta, hostRef, hmrVersionId) => {
  const exportName = cmpMeta.$tagName$.replace(/-/g, "_");
  const bundleId = cmpMeta.$lazyBundleId$;
  if (!bundleId) {
    return void 0;
  }
  const module = cmpModules.get(bundleId) ;
  if (module) {
    return module[exportName];
  }
  /*!__STENCIL_STATIC_IMPORT_SWITCH__*/
  return import(
    /* @vite-ignore */
    /* webpackInclude: /\.entry\.js$/ */
    /* webpackExclude: /\.system\.entry\.js$/ */
    /* webpackMode: "lazy" */
    `./${bundleId}.entry.js${""}`
  ).then(
    (importedModule) => {
      {
        cmpModules.set(bundleId, importedModule);
      }
      return importedModule[exportName];
    },
    (e) => {
      consoleError(e, hostRef.$hostElement$);
    }
  );
};

// src/client/client-style.ts
var styles = /* @__PURE__ */ new Map();
var HYDRATED_CSS = "{visibility:hidden}.hydrated{visibility:inherit}";
var SLOT_FB_CSS = "slot-fb{display:contents}slot-fb[hidden]{display:none}";
var XLINK_NS = "http://www.w3.org/1999/xlink";
var win = typeof window !== "undefined" ? window : {};
var plt = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (h2) => h2(),
  raf: (h2) => requestAnimationFrame(h2),
  ael: (el, eventName, listener, opts) => el.addEventListener(eventName, listener, opts),
  rel: (el, eventName, listener, opts) => el.removeEventListener(eventName, listener, opts),
  ce: (eventName, opts) => new CustomEvent(eventName, opts)
};
var supportsListenerOptions = /* @__PURE__ */ (() => {
  var _a;
  let supportsListenerOptions2 = false;
  try {
    (_a = win.document) == null ? void 0 : _a.addEventListener(
      "e",
      null,
      Object.defineProperty({}, "passive", {
        get() {
          supportsListenerOptions2 = true;
        }
      })
    );
  } catch (e) {
  }
  return supportsListenerOptions2;
})();
var promiseResolve = (v) => Promise.resolve(v);
var supportsConstructableStylesheets = /* @__PURE__ */ (() => {
  try {
    new CSSStyleSheet();
    return typeof new CSSStyleSheet().replaceSync === "function";
  } catch (e) {
  }
  return false;
})() ;
var supportsMutableAdoptedStyleSheets = supportsConstructableStylesheets ? /* @__PURE__ */ (() => !!win.document && Object.getOwnPropertyDescriptor(win.document.adoptedStyleSheets, "length").writable)() : false;
var queuePending = false;
var queueDomReads = [];
var queueDomWrites = [];
var queueTask = (queue, write) => (cb) => {
  queue.push(cb);
  if (!queuePending) {
    queuePending = true;
    if (write && plt.$flags$ & 4 /* queueSync */) {
      nextTick(flush);
    } else {
      plt.raf(flush);
    }
  }
};
var consume = (queue) => {
  for (let i2 = 0; i2 < queue.length; i2++) {
    try {
      queue[i2](performance.now());
    } catch (e) {
      consoleError(e);
    }
  }
  queue.length = 0;
};
var flush = () => {
  consume(queueDomReads);
  {
    consume(queueDomWrites);
    if (queuePending = queueDomReads.length > 0) {
      plt.raf(flush);
    }
  }
};
var nextTick = (cb) => promiseResolve().then(cb);
var writeTask = /* @__PURE__ */ queueTask(queueDomWrites, true);
var isComplexType = (o) => {
  o = typeof o;
  return o === "object" || o === "function";
};

// src/utils/query-nonce-meta-tag-content.ts
function queryNonceMetaTagContent(doc) {
  var _a, _b, _c;
  return (_c = (_b = (_a = doc.head) == null ? void 0 : _a.querySelector('meta[name="csp-nonce"]')) == null ? void 0 : _b.getAttribute("content")) != null ? _c : void 0;
}

// src/utils/regular-expression.ts
var escapeRegExpSpecialCharacters = (text) => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

// src/utils/result.ts
var result_exports = {};
__export(result_exports, {
  err: () => err,
  map: () => map,
  ok: () => ok,
  unwrap: () => unwrap,
  unwrapErr: () => unwrapErr
});
var ok = (value) => ({
  isOk: true,
  isErr: false,
  value
});
var err = (value) => ({
  isOk: false,
  isErr: true,
  value
});
function map(result, fn) {
  if (result.isOk) {
    const val = fn(result.value);
    if (val instanceof Promise) {
      return val.then((newVal) => ok(newVal));
    } else {
      return ok(val);
    }
  }
  if (result.isErr) {
    const value = result.value;
    return err(value);
  }
  throw "should never get here";
}
var unwrap = (result) => {
  if (result.isOk) {
    return result.value;
  } else {
    throw result.value;
  }
};
var unwrapErr = (result) => {
  if (result.isErr) {
    return result.value;
  } else {
    throw result.value;
  }
};

// src/utils/style.ts
function createStyleSheetIfNeededAndSupported(styles2) {
  if (!supportsConstructableStylesheets) return void 0;
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(styles2);
  return sheet;
}

// src/utils/shadow-root.ts
var globalStyleSheet;
function createShadowRoot(cmpMeta) {
  var _a;
  const shadowRoot = this.attachShadow({ mode: "open" });
  if (globalStyleSheet === void 0) globalStyleSheet = (_a = createStyleSheetIfNeededAndSupported(globalStyles)) != null ? _a : null;
  if (globalStyleSheet) {
    if (supportsMutableAdoptedStyleSheets) {
      shadowRoot.adoptedStyleSheets.push(globalStyleSheet);
    } else {
      shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, globalStyleSheet];
    }
  }
}
var updateFallbackSlotVisibility = (elm) => {
  const childNodes = internalCall(elm, "childNodes");
  if (elm.tagName && elm.tagName.includes("-") && elm["s-cr"] && elm.tagName !== "SLOT-FB") {
    getHostSlotNodes(childNodes, elm.tagName).forEach((slotNode) => {
      if (slotNode.nodeType === 1 /* ElementNode */ && slotNode.tagName === "SLOT-FB") {
        if (getSlotChildSiblings(slotNode, getSlotName(slotNode), false).length) {
          slotNode.hidden = true;
        } else {
          slotNode.hidden = false;
        }
      }
    });
  }
  let i2 = 0;
  for (i2 = 0; i2 < childNodes.length; i2++) {
    const childNode = childNodes[i2];
    if (childNode.nodeType === 1 /* ElementNode */ && internalCall(childNode, "childNodes").length) {
      updateFallbackSlotVisibility(childNode);
    }
  }
};
var getSlottedChildNodes = (childNodes) => {
  const result = [];
  for (let i2 = 0; i2 < childNodes.length; i2++) {
    const slottedNode = childNodes[i2]["s-nr"] || void 0;
    if (slottedNode && slottedNode.isConnected) {
      result.push(slottedNode);
    }
  }
  return result;
};
function getHostSlotNodes(childNodes, hostName, slotName) {
  let i2 = 0;
  let slottedNodes = [];
  let childNode;
  for (; i2 < childNodes.length; i2++) {
    childNode = childNodes[i2];
    if (childNode["s-sr"] && (!hostName || childNode["s-hn"] === hostName) && (slotName === void 0)) {
      slottedNodes.push(childNode);
    }
    slottedNodes = [...slottedNodes, ...getHostSlotNodes(childNode.childNodes, hostName, slotName)];
  }
  return slottedNodes;
}
var getSlotChildSiblings = (slot, slotName, includeSlot = true) => {
  const childNodes = [];
  if (includeSlot && slot["s-sr"] || !slot["s-sr"]) childNodes.push(slot);
  let node = slot;
  while (node = node.nextSibling) {
    if (getSlotName(node) === slotName && (includeSlot || !node["s-sr"])) childNodes.push(node);
  }
  return childNodes;
};
var isNodeLocatedInSlot = (nodeToRelocate, slotName) => {
  if (nodeToRelocate.nodeType === 1 /* ElementNode */) {
    if (nodeToRelocate.getAttribute("slot") === null && slotName === "") {
      return true;
    }
    if (nodeToRelocate.getAttribute("slot") === slotName) {
      return true;
    }
    return false;
  }
  if (nodeToRelocate["s-sn"] === slotName) {
    return true;
  }
  return slotName === "";
};
var getSlotName = (node) => typeof node["s-sn"] === "string" ? node["s-sn"] : node.nodeType === 1 && node.getAttribute("slot") || void 0;
function patchSlotNode(node) {
  if (node.assignedElements || node.assignedNodes || !node["s-sr"]) return;
  const assignedFactory = (elementsOnly) => (function(opts) {
    const toReturn = [];
    const slotName = this["s-sn"];
    if (opts == null ? void 0 : opts.flatten) {
      console.error(`
          Flattening is not supported for Stencil non-shadow slots.
          You can use \`.childNodes\` to nested slot fallback content.
          If you have a particular use case, please open an issue on the Stencil repo.
        `);
    }
    const parent = this["s-cr"].parentElement;
    const slottedNodes = parent.__childNodes ? parent.childNodes : getSlottedChildNodes(parent.childNodes);
    slottedNodes.forEach((n) => {
      if (slotName === getSlotName(n)) {
        toReturn.push(n);
      }
    });
    if (elementsOnly) {
      return toReturn.filter((n) => n.nodeType === 1 /* ElementNode */);
    }
    return toReturn;
  }).bind(node);
  node.assignedElements = assignedFactory(true);
  node.assignedNodes = assignedFactory(false);
}
function internalCall(node, method) {
  if ("__" + method in node) {
    const toReturn = node["__" + method];
    if (typeof toReturn !== "function") return toReturn;
    return toReturn.bind(node);
  } else {
    if (typeof node[method] !== "function") return node[method];
    return node[method].bind(node);
  }
}
var createTime = (fnName, tagName = "") => {
  {
    return () => {
      return;
    };
  }
};
var uniqueTime = (key, measureText) => {
  {
    return () => {
      return;
    };
  }
};
var rootAppliedStyles = /* @__PURE__ */ new WeakMap();
var registerStyle = (scopeId2, cssText, allowCS) => {
  let style = styles.get(scopeId2);
  if (supportsConstructableStylesheets && allowCS) {
    style = style || new CSSStyleSheet();
    if (typeof style === "string") {
      style = cssText;
    } else {
      style.replaceSync(cssText);
    }
  } else {
    style = cssText;
  }
  styles.set(scopeId2, style);
};
var addStyle = (styleContainerNode, cmpMeta, mode) => {
  var _a;
  const scopeId2 = getScopeId(cmpMeta);
  const style = styles.get(scopeId2);
  if (!win.document) {
    return scopeId2;
  }
  styleContainerNode = styleContainerNode.nodeType === 11 /* DocumentFragment */ ? styleContainerNode : win.document;
  if (style) {
    if (typeof style === "string") {
      styleContainerNode = styleContainerNode.head || styleContainerNode;
      let appliedStyles = rootAppliedStyles.get(styleContainerNode);
      let styleElm;
      if (!appliedStyles) {
        rootAppliedStyles.set(styleContainerNode, appliedStyles = /* @__PURE__ */ new Set());
      }
      if (!appliedStyles.has(scopeId2)) {
        {
          styleElm = win.document.createElement("style");
          styleElm.innerHTML = style;
          const nonce = (_a = plt.$nonce$) != null ? _a : queryNonceMetaTagContent(win.document);
          if (nonce != null) {
            styleElm.setAttribute("nonce", nonce);
          }
          if (!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */)) {
            if (styleContainerNode.nodeName === "HEAD") {
              const preconnectLinks = styleContainerNode.querySelectorAll("link[rel=preconnect]");
              const referenceNode2 = preconnectLinks.length > 0 ? preconnectLinks[preconnectLinks.length - 1].nextSibling : styleContainerNode.querySelector("style");
              styleContainerNode.insertBefore(
                styleElm,
                (referenceNode2 == null ? void 0 : referenceNode2.parentNode) === styleContainerNode ? referenceNode2 : null
              );
            } else if ("host" in styleContainerNode) {
              if (supportsConstructableStylesheets) {
                const stylesheet = new CSSStyleSheet();
                stylesheet.replaceSync(style);
                if (supportsMutableAdoptedStyleSheets) {
                  styleContainerNode.adoptedStyleSheets.unshift(stylesheet);
                } else {
                  styleContainerNode.adoptedStyleSheets = [stylesheet, ...styleContainerNode.adoptedStyleSheets];
                }
              } else {
                const existingStyleContainer = styleContainerNode.querySelector("style");
                if (existingStyleContainer) {
                  existingStyleContainer.innerHTML = style + existingStyleContainer.innerHTML;
                } else {
                  styleContainerNode.prepend(styleElm);
                }
              }
            } else {
              styleContainerNode.append(styleElm);
            }
          }
          if (cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */) {
            styleContainerNode.insertBefore(styleElm, null);
          }
        }
        if (cmpMeta.$flags$ & 4 /* hasSlotRelocation */) {
          styleElm.innerHTML += SLOT_FB_CSS;
        }
        if (appliedStyles) {
          appliedStyles.add(scopeId2);
        }
      }
    } else if (!styleContainerNode.adoptedStyleSheets.includes(style)) {
      if (supportsMutableAdoptedStyleSheets) {
        styleContainerNode.adoptedStyleSheets.push(style);
      } else {
        styleContainerNode.adoptedStyleSheets = [...styleContainerNode.adoptedStyleSheets, style];
      }
    }
  }
  return scopeId2;
};
var attachStyles = (hostRef) => {
  const cmpMeta = hostRef.$cmpMeta$;
  const elm = hostRef.$hostElement$;
  const flags = cmpMeta.$flags$;
  const endAttachStyles = createTime("attachStyles", cmpMeta.$tagName$);
  const scopeId2 = addStyle(
    elm.shadowRoot ? elm.shadowRoot : elm.getRootNode(),
    cmpMeta);
  if (flags & 10 /* needsScopedEncapsulation */) {
    elm["s-sc"] = scopeId2;
    elm.classList.add(scopeId2 + "-h");
  }
  endAttachStyles();
};
var getScopeId = (cmp, mode) => "sc-" + (cmp.$tagName$);
var h = (nodeName, vnodeData, ...children) => {
  let child = null;
  let key = null;
  let slotName = null;
  let simple = false;
  let lastSimple = false;
  const vNodeChildren = [];
  const walk = (c) => {
    for (let i2 = 0; i2 < c.length; i2++) {
      child = c[i2];
      if (Array.isArray(child)) {
        walk(child);
      } else if (child != null && typeof child !== "boolean") {
        if (simple = typeof nodeName !== "function" && !isComplexType(child)) {
          child = String(child);
        }
        if (simple && lastSimple) {
          vNodeChildren[vNodeChildren.length - 1].$text$ += child;
        } else {
          vNodeChildren.push(simple ? newVNode(null, child) : child);
        }
        lastSimple = simple;
      }
    }
  };
  walk(children);
  if (vnodeData) {
    if (vnodeData.key) {
      key = vnodeData.key;
    }
    if (vnodeData.name) {
      slotName = vnodeData.name;
    }
    {
      const classData = vnodeData.className || vnodeData.class;
      if (classData) {
        vnodeData.class = typeof classData !== "object" ? classData : Object.keys(classData).filter((k) => classData[k]).join(" ");
      }
    }
  }
  if (typeof nodeName === "function") {
    return nodeName(
      vnodeData === null ? {} : vnodeData,
      vNodeChildren,
      vdomFnUtils
    );
  }
  const vnode = newVNode(nodeName, null);
  vnode.$attrs$ = vnodeData;
  if (vNodeChildren.length > 0) {
    vnode.$children$ = vNodeChildren;
  }
  {
    vnode.$key$ = key;
  }
  {
    vnode.$name$ = slotName;
  }
  return vnode;
};
var newVNode = (tag, text) => {
  const vnode = {
    $flags$: 0,
    $tag$: tag,
    $text$: text,
    $elm$: null,
    $children$: null
  };
  {
    vnode.$attrs$ = null;
  }
  {
    vnode.$key$ = null;
  }
  {
    vnode.$name$ = null;
  }
  return vnode;
};
var Host = {};
var isHost = (node) => node && node.$tag$ === Host;
var vdomFnUtils = {
  forEach: (children, cb) => children.map(convertToPublic).forEach(cb),
  map: (children, cb) => children.map(convertToPublic).map(cb).map(convertToPrivate)
};
var convertToPublic = (node) => ({
  vattrs: node.$attrs$,
  vchildren: node.$children$,
  vkey: node.$key$,
  vname: node.$name$,
  vtag: node.$tag$,
  vtext: node.$text$
});
var convertToPrivate = (node) => {
  if (typeof node.vtag === "function") {
    const vnodeData = { ...node.vattrs };
    if (node.vkey) {
      vnodeData.key = node.vkey;
    }
    if (node.vname) {
      vnodeData.name = node.vname;
    }
    return h(node.vtag, vnodeData, ...node.vchildren || []);
  }
  const vnode = newVNode(node.vtag, node.vtext);
  vnode.$attrs$ = node.vattrs;
  vnode.$children$ = node.vchildren;
  vnode.$key$ = node.vkey;
  vnode.$name$ = node.vname;
  return vnode;
};
var createSupportsRuleRe = (selector) => {
  const safeSelector2 = escapeRegExpSpecialCharacters(selector);
  return new RegExp(
    // First capture group: match any context before the selector that's not inside @supports selector()
    // Using negative lookahead to avoid matching inside @supports selector(...) condition
    `(^|[^@]|@(?!supports\\s+selector\\s*\\([^{]*?${safeSelector2}))(${safeSelector2}\\b)`,
    "g"
  );
};
createSupportsRuleRe("::slotted");
createSupportsRuleRe(":host");
createSupportsRuleRe(":host-context");
var parsePropertyValue = (propValue, propType, isFormAssociated) => {
  if (propValue != null && !isComplexType(propValue)) {
    if (propType & 4 /* Boolean */) {
      {
        return propValue === "false" ? false : propValue === "" || !!propValue;
      }
    }
    if (propType & 2 /* Number */) {
      return typeof propValue === "string" ? parseFloat(propValue) : typeof propValue === "number" ? propValue : NaN;
    }
    if (propType & 1 /* String */) {
      return String(propValue);
    }
    return propValue;
  }
  return propValue;
};
var getElement = (ref) => {
  var _a;
  return (_a = getHostRef(ref)) == null ? void 0 : _a.$hostElement$ ;
};

// src/runtime/event-emitter.ts
var createEvent = (ref, name, flags) => {
  const elm = getElement(ref);
  return {
    emit: (detail) => {
      return emitEvent(elm, name, {
        bubbles: true,
        composed: true,
        cancelable: true,
        detail
      });
    }
  };
};
var emitEvent = (elm, name, opts) => {
  const ev = plt.ce(name, opts);
  elm.dispatchEvent(ev);
  return ev;
};
var setAccessor = (elm, memberName, oldValue, newValue, isSvg, flags, initialRender) => {
  if (oldValue === newValue) {
    return;
  }
  let isProp = isMemberInElement(elm, memberName);
  let ln = memberName.toLowerCase();
  if (memberName === "class") {
    const classList = elm.classList;
    const oldClasses = parseClassList(oldValue);
    let newClasses = parseClassList(newValue);
    {
      classList.remove(...oldClasses.filter((c) => c && !newClasses.includes(c)));
      classList.add(...newClasses.filter((c) => c && !oldClasses.includes(c)));
    }
  } else if (memberName === "style") {
    {
      for (const prop in oldValue) {
        if (!newValue || newValue[prop] == null) {
          if (prop.includes("-")) {
            elm.style.removeProperty(prop);
          } else {
            elm.style[prop] = "";
          }
        }
      }
    }
    for (const prop in newValue) {
      if (!oldValue || newValue[prop] !== oldValue[prop]) {
        if (prop.includes("-")) {
          elm.style.setProperty(prop, newValue[prop]);
        } else {
          elm.style[prop] = newValue[prop];
        }
      }
    }
  } else if (memberName === "key") ; else if (memberName === "ref") {
    if (newValue) {
      newValue(elm);
    }
  } else if ((!isProp ) && memberName[0] === "o" && memberName[1] === "n") {
    if (memberName[2] === "-") {
      memberName = memberName.slice(3);
    } else if (isMemberInElement(win, ln)) {
      memberName = ln.slice(2);
    } else {
      memberName = ln[2] + memberName.slice(3);
    }
    if (oldValue || newValue) {
      const capture = memberName.endsWith(CAPTURE_EVENT_SUFFIX);
      memberName = memberName.replace(CAPTURE_EVENT_REGEX, "");
      if (oldValue) {
        plt.rel(elm, memberName, oldValue, capture);
      }
      if (newValue) {
        plt.ael(elm, memberName, newValue, capture);
      }
    }
  } else {
    const isComplex = isComplexType(newValue);
    if ((isProp || isComplex && newValue !== null) && !isSvg) {
      try {
        if (!elm.tagName.includes("-")) {
          const n = newValue == null ? "" : newValue;
          if (memberName === "list") {
            isProp = false;
          } else if (oldValue == null || elm[memberName] != n) {
            if (typeof elm.__lookupSetter__(memberName) === "function") {
              elm[memberName] = n;
            } else {
              elm.setAttribute(memberName, n);
            }
          }
        } else if (elm[memberName] !== newValue) {
          elm[memberName] = newValue;
        }
      } catch (e) {
      }
    }
    let xlink = false;
    {
      if (ln !== (ln = ln.replace(/^xlink\:?/, ""))) {
        memberName = ln;
        xlink = true;
      }
    }
    if (newValue == null || newValue === false) {
      if (newValue !== false || elm.getAttribute(memberName) === "") {
        if (xlink) {
          elm.removeAttributeNS(XLINK_NS, memberName);
        } else {
          elm.removeAttribute(memberName);
        }
      }
    } else if ((!isProp || flags & 4 /* isHost */ || isSvg) && !isComplex && elm.nodeType === 1 /* ElementNode */) {
      newValue = newValue === true ? "" : newValue;
      if (xlink) {
        elm.setAttributeNS(XLINK_NS, memberName, newValue);
      } else {
        elm.setAttribute(memberName, newValue);
      }
    }
  }
};
var parseClassListRegex = /\s/;
var parseClassList = (value) => {
  if (typeof value === "object" && value && "baseVal" in value) {
    value = value.baseVal;
  }
  if (!value || typeof value !== "string") {
    return [];
  }
  return value.split(parseClassListRegex);
};
var CAPTURE_EVENT_SUFFIX = "Capture";
var CAPTURE_EVENT_REGEX = new RegExp(CAPTURE_EVENT_SUFFIX + "$");

// src/runtime/vdom/update-element.ts
var updateElement = (oldVnode, newVnode, isSvgMode2, isInitialRender) => {
  const elm = newVnode.$elm$.nodeType === 11 /* DocumentFragment */ && newVnode.$elm$.host ? newVnode.$elm$.host : newVnode.$elm$;
  const oldVnodeAttrs = oldVnode && oldVnode.$attrs$ || {};
  const newVnodeAttrs = newVnode.$attrs$ || {};
  {
    for (const memberName of sortedAttrNames(Object.keys(oldVnodeAttrs))) {
      if (!(memberName in newVnodeAttrs)) {
        setAccessor(
          elm,
          memberName,
          oldVnodeAttrs[memberName],
          void 0,
          isSvgMode2,
          newVnode.$flags$);
      }
    }
  }
  for (const memberName of sortedAttrNames(Object.keys(newVnodeAttrs))) {
    setAccessor(
      elm,
      memberName,
      oldVnodeAttrs[memberName],
      newVnodeAttrs[memberName],
      isSvgMode2,
      newVnode.$flags$);
  }
};
function sortedAttrNames(attrNames) {
  return attrNames.includes("ref") ? (
    // we need to sort these to ensure that `'ref'` is the last attr
    [...attrNames.filter((attr) => attr !== "ref"), "ref"]
  ) : (
    // no need to sort, return the original array
    attrNames
  );
}
var contentRef;
var hostTagName;
var useNativeShadowDom = false;
var checkSlotFallbackVisibility = false;
var checkSlotRelocate = false;
var isSvgMode = false;
var createElm = (oldParentVNode, newParentVNode, childIndex) => {
  var _a;
  const newVNode2 = newParentVNode.$children$[childIndex];
  let i2 = 0;
  let elm;
  let childNode;
  let oldVNode;
  if (!useNativeShadowDom) {
    checkSlotRelocate = true;
    if (newVNode2.$tag$ === "slot") {
      newVNode2.$flags$ |= newVNode2.$children$ ? (
        // slot element has fallback content
        // still create an element that "mocks" the slot element
        2 /* isSlotFallback */
      ) : (
        // slot element does not have fallback content
        // create an html comment we'll use to always reference
        // where actual slot content should sit next to
        1 /* isSlotReference */
      );
    }
  }
  if (newVNode2.$text$ !== null) {
    elm = newVNode2.$elm$ = win.document.createTextNode(newVNode2.$text$);
  } else if (newVNode2.$flags$ & 1 /* isSlotReference */) {
    elm = newVNode2.$elm$ = win.document.createTextNode("");
    {
      updateElement(null, newVNode2, isSvgMode);
    }
  } else {
    if (!isSvgMode) {
      isSvgMode = newVNode2.$tag$ === "svg";
    }
    if (!win.document) {
      throw new Error(
        "You are trying to render a Stencil component in an environment that doesn't support the DOM. Make sure to populate the [`window`](https://developer.mozilla.org/en-US/docs/Web/API/Window/window) object before rendering a component."
      );
    }
    elm = newVNode2.$elm$ = win.document.createElementNS(
      isSvgMode ? SVG_NS : HTML_NS,
      !useNativeShadowDom && BUILD.slotRelocation && newVNode2.$flags$ & 2 /* isSlotFallback */ ? "slot-fb" : newVNode2.$tag$
    ) ;
    if (isSvgMode && newVNode2.$tag$ === "foreignObject") {
      isSvgMode = false;
    }
    {
      updateElement(null, newVNode2, isSvgMode);
    }
    if (newVNode2.$children$) {
      for (i2 = 0; i2 < newVNode2.$children$.length; ++i2) {
        childNode = createElm(oldParentVNode, newVNode2, i2);
        if (childNode) {
          elm.appendChild(childNode);
        }
      }
    }
    {
      if (newVNode2.$tag$ === "svg") {
        isSvgMode = false;
      } else if (elm.tagName === "foreignObject") {
        isSvgMode = true;
      }
    }
  }
  elm["s-hn"] = hostTagName;
  {
    if (newVNode2.$flags$ & (2 /* isSlotFallback */ | 1 /* isSlotReference */)) {
      elm["s-sr"] = true;
      elm["s-cr"] = contentRef;
      elm["s-sn"] = newVNode2.$name$ || "";
      elm["s-rf"] = (_a = newVNode2.$attrs$) == null ? void 0 : _a.ref;
      patchSlotNode(elm);
      oldVNode = oldParentVNode && oldParentVNode.$children$ && oldParentVNode.$children$[childIndex];
      if (oldVNode && oldVNode.$tag$ === newVNode2.$tag$ && oldParentVNode.$elm$) {
        {
          putBackInOriginalLocation(oldParentVNode.$elm$, false);
        }
      }
    }
  }
  return elm;
};
var putBackInOriginalLocation = (parentElm, recursive) => {
  plt.$flags$ |= 1 /* isTmpDisconnected */;
  const oldSlotChildNodes = Array.from(parentElm.__childNodes || parentElm.childNodes);
  for (let i2 = oldSlotChildNodes.length - 1; i2 >= 0; i2--) {
    const childNode = oldSlotChildNodes[i2];
    if (childNode["s-hn"] !== hostTagName && childNode["s-ol"]) {
      insertBefore(referenceNode(childNode).parentNode, childNode, referenceNode(childNode));
      childNode["s-ol"].remove();
      childNode["s-ol"] = void 0;
      childNode["s-sh"] = void 0;
      checkSlotRelocate = true;
    }
    if (recursive) {
      putBackInOriginalLocation(childNode, recursive);
    }
  }
  plt.$flags$ &= -2 /* isTmpDisconnected */;
};
var addVnodes = (parentElm, before, parentVNode, vnodes, startIdx, endIdx) => {
  let containerElm = parentElm["s-cr"] && parentElm["s-cr"].parentNode || parentElm;
  let childNode;
  if (containerElm.shadowRoot && containerElm.tagName === hostTagName) {
    containerElm = containerElm.shadowRoot;
  }
  for (; startIdx <= endIdx; ++startIdx) {
    if (vnodes[startIdx]) {
      childNode = createElm(null, parentVNode, startIdx);
      if (childNode) {
        vnodes[startIdx].$elm$ = childNode;
        insertBefore(containerElm, childNode, referenceNode(before) );
      }
    }
  }
};
var removeVnodes = (vnodes, startIdx, endIdx) => {
  for (let index = startIdx; index <= endIdx; ++index) {
    const vnode = vnodes[index];
    if (vnode) {
      const elm = vnode.$elm$;
      nullifyVNodeRefs(vnode);
      if (elm) {
        {
          checkSlotFallbackVisibility = true;
          if (elm["s-ol"]) {
            elm["s-ol"].remove();
          } else {
            putBackInOriginalLocation(elm, true);
          }
        }
        elm.remove();
      }
    }
  }
};
var updateChildren = (parentElm, oldCh, newVNode2, newCh, isInitialRender = false) => {
  let oldStartIdx = 0;
  let newStartIdx = 0;
  let idxInOld = 0;
  let i2 = 0;
  let oldEndIdx = oldCh.length - 1;
  let oldStartVnode = oldCh[0];
  let oldEndVnode = oldCh[oldEndIdx];
  let newEndIdx = newCh.length - 1;
  let newStartVnode = newCh[0];
  let newEndVnode = newCh[newEndIdx];
  let node;
  let elmToMove;
  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (oldStartVnode == null) {
      oldStartVnode = oldCh[++oldStartIdx];
    } else if (oldEndVnode == null) {
      oldEndVnode = oldCh[--oldEndIdx];
    } else if (newStartVnode == null) {
      newStartVnode = newCh[++newStartIdx];
    } else if (newEndVnode == null) {
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldStartVnode, newStartVnode, isInitialRender)) {
      patch(oldStartVnode, newStartVnode, isInitialRender);
      oldStartVnode = oldCh[++oldStartIdx];
      newStartVnode = newCh[++newStartIdx];
    } else if (isSameVnode(oldEndVnode, newEndVnode, isInitialRender)) {
      patch(oldEndVnode, newEndVnode, isInitialRender);
      oldEndVnode = oldCh[--oldEndIdx];
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldStartVnode, newEndVnode, isInitialRender)) {
      if ((oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot")) {
        putBackInOriginalLocation(oldStartVnode.$elm$.parentNode, false);
      }
      patch(oldStartVnode, newEndVnode, isInitialRender);
      insertBefore(parentElm, oldStartVnode.$elm$, oldEndVnode.$elm$.nextSibling);
      oldStartVnode = oldCh[++oldStartIdx];
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldEndVnode, newStartVnode, isInitialRender)) {
      if ((oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot")) {
        putBackInOriginalLocation(oldEndVnode.$elm$.parentNode, false);
      }
      patch(oldEndVnode, newStartVnode, isInitialRender);
      insertBefore(parentElm, oldEndVnode.$elm$, oldStartVnode.$elm$);
      oldEndVnode = oldCh[--oldEndIdx];
      newStartVnode = newCh[++newStartIdx];
    } else {
      idxInOld = -1;
      {
        for (i2 = oldStartIdx; i2 <= oldEndIdx; ++i2) {
          if (oldCh[i2] && oldCh[i2].$key$ !== null && oldCh[i2].$key$ === newStartVnode.$key$) {
            idxInOld = i2;
            break;
          }
        }
      }
      if (idxInOld >= 0) {
        elmToMove = oldCh[idxInOld];
        if (elmToMove.$tag$ !== newStartVnode.$tag$) {
          node = createElm(oldCh && oldCh[newStartIdx], newVNode2, idxInOld);
        } else {
          patch(elmToMove, newStartVnode, isInitialRender);
          oldCh[idxInOld] = void 0;
          node = elmToMove.$elm$;
        }
        newStartVnode = newCh[++newStartIdx];
      } else {
        node = createElm(oldCh && oldCh[newStartIdx], newVNode2, newStartIdx);
        newStartVnode = newCh[++newStartIdx];
      }
      if (node) {
        {
          insertBefore(
            referenceNode(oldStartVnode.$elm$).parentNode,
            node,
            referenceNode(oldStartVnode.$elm$)
          );
        }
      }
    }
  }
  if (oldStartIdx > oldEndIdx) {
    addVnodes(
      parentElm,
      newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].$elm$,
      newVNode2,
      newCh,
      newStartIdx,
      newEndIdx
    );
  } else if (newStartIdx > newEndIdx) {
    removeVnodes(oldCh, oldStartIdx, oldEndIdx);
  }
};
var isSameVnode = (leftVNode, rightVNode, isInitialRender = false) => {
  if (leftVNode.$tag$ === rightVNode.$tag$) {
    if (leftVNode.$tag$ === "slot") {
      return leftVNode.$name$ === rightVNode.$name$;
    }
    if (!isInitialRender) {
      return leftVNode.$key$ === rightVNode.$key$;
    }
    if (isInitialRender && !leftVNode.$key$ && rightVNode.$key$) {
      leftVNode.$key$ = rightVNode.$key$;
    }
    return true;
  }
  return false;
};
var referenceNode = (node) => node && node["s-ol"] || node;
var patch = (oldVNode, newVNode2, isInitialRender = false) => {
  const elm = newVNode2.$elm$ = oldVNode.$elm$;
  const oldChildren = oldVNode.$children$;
  const newChildren = newVNode2.$children$;
  const tag = newVNode2.$tag$;
  const text = newVNode2.$text$;
  let defaultHolder;
  if (text === null) {
    {
      isSvgMode = tag === "svg" ? true : tag === "foreignObject" ? false : isSvgMode;
    }
    {
      updateElement(oldVNode, newVNode2, isSvgMode);
    }
    if (oldChildren !== null && newChildren !== null) {
      updateChildren(elm, oldChildren, newVNode2, newChildren, isInitialRender);
    } else if (newChildren !== null) {
      if (oldVNode.$text$ !== null) {
        elm.textContent = "";
      }
      addVnodes(elm, null, newVNode2, newChildren, 0, newChildren.length - 1);
    } else if (
      // don't do this on initial render as it can cause non-hydrated content to be removed
      !isInitialRender && BUILD.updatable && oldChildren !== null
    ) {
      removeVnodes(oldChildren, 0, oldChildren.length - 1);
    } else ;
    if (isSvgMode && tag === "svg") {
      isSvgMode = false;
    }
  } else if ((defaultHolder = elm["s-cr"])) {
    defaultHolder.parentNode.textContent = text;
  } else if (oldVNode.$text$ !== text) {
    elm.data = text;
  }
};
var relocateNodes = [];
var markSlotContentForRelocation = (elm) => {
  let node;
  let hostContentNodes;
  let j;
  const children = elm.__childNodes || elm.childNodes;
  for (const childNode of children) {
    if (childNode["s-sr"] && (node = childNode["s-cr"]) && node.parentNode) {
      hostContentNodes = node.parentNode.__childNodes || node.parentNode.childNodes;
      const slotName = childNode["s-sn"];
      for (j = hostContentNodes.length - 1; j >= 0; j--) {
        node = hostContentNodes[j];
        if (!node["s-cn"] && !node["s-nr"] && node["s-hn"] !== childNode["s-hn"] && (true)) {
          if (isNodeLocatedInSlot(node, slotName)) {
            let relocateNodeData = relocateNodes.find((r) => r.$nodeToRelocate$ === node);
            checkSlotFallbackVisibility = true;
            node["s-sn"] = node["s-sn"] || slotName;
            if (relocateNodeData) {
              relocateNodeData.$nodeToRelocate$["s-sh"] = childNode["s-hn"];
              relocateNodeData.$slotRefNode$ = childNode;
            } else {
              node["s-sh"] = childNode["s-hn"];
              relocateNodes.push({
                $slotRefNode$: childNode,
                $nodeToRelocate$: node
              });
            }
            if (node["s-sr"]) {
              relocateNodes.map((relocateNode) => {
                if (isNodeLocatedInSlot(relocateNode.$nodeToRelocate$, node["s-sn"])) {
                  relocateNodeData = relocateNodes.find((r) => r.$nodeToRelocate$ === node);
                  if (relocateNodeData && !relocateNode.$slotRefNode$) {
                    relocateNode.$slotRefNode$ = relocateNodeData.$slotRefNode$;
                  }
                }
              });
            }
          } else if (!relocateNodes.some((r) => r.$nodeToRelocate$ === node)) {
            relocateNodes.push({
              $nodeToRelocate$: node
            });
          }
        }
      }
    }
    if (childNode.nodeType === 1 /* ElementNode */) {
      markSlotContentForRelocation(childNode);
    }
  }
};
var nullifyVNodeRefs = (vNode) => {
  {
    vNode.$attrs$ && vNode.$attrs$.ref && vNode.$attrs$.ref(null);
    vNode.$children$ && vNode.$children$.map(nullifyVNodeRefs);
  }
};
var insertBefore = (parent, newNode, reference) => {
  {
    return parent == null ? void 0 : parent.insertBefore(newNode, reference);
  }
};
var renderVdom = (hostRef, renderFnResults, isInitialLoad = false) => {
  var _a, _b, _c, _d;
  const hostElm = hostRef.$hostElement$;
  const cmpMeta = hostRef.$cmpMeta$;
  const oldVNode = hostRef.$vnode$ || newVNode(null, null);
  const isHostElement = isHost(renderFnResults);
  const rootVnode = isHostElement ? renderFnResults : h(null, null, renderFnResults);
  hostTagName = hostElm.tagName;
  if (cmpMeta.$attrsToReflect$) {
    rootVnode.$attrs$ = rootVnode.$attrs$ || {};
    cmpMeta.$attrsToReflect$.forEach(([propName, attribute]) => {
      {
        rootVnode.$attrs$[attribute] = hostElm[propName];
      }
    });
  }
  if (isInitialLoad && rootVnode.$attrs$) {
    for (const key of Object.keys(rootVnode.$attrs$)) {
      if (hostElm.hasAttribute(key) && !["key", "ref", "style", "class"].includes(key)) {
        rootVnode.$attrs$[key] = hostElm[key];
      }
    }
  }
  rootVnode.$tag$ = null;
  rootVnode.$flags$ |= 4 /* isHost */;
  hostRef.$vnode$ = rootVnode;
  rootVnode.$elm$ = oldVNode.$elm$ = hostElm.shadowRoot || hostElm ;
  useNativeShadowDom = !!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */) && !(cmpMeta.$flags$ & 128 /* shadowNeedsScopedCss */);
  {
    contentRef = hostElm["s-cr"];
    checkSlotFallbackVisibility = false;
  }
  patch(oldVNode, rootVnode, isInitialLoad);
  {
    plt.$flags$ |= 1 /* isTmpDisconnected */;
    if (checkSlotRelocate) {
      markSlotContentForRelocation(rootVnode.$elm$);
      for (const relocateData of relocateNodes) {
        const nodeToRelocate = relocateData.$nodeToRelocate$;
        if (!nodeToRelocate["s-ol"] && win.document) {
          const orgLocationNode = win.document.createTextNode("");
          orgLocationNode["s-nr"] = nodeToRelocate;
          insertBefore(nodeToRelocate.parentNode, nodeToRelocate["s-ol"] = orgLocationNode, nodeToRelocate);
        }
      }
      for (const relocateData of relocateNodes) {
        const nodeToRelocate = relocateData.$nodeToRelocate$;
        const slotRefNode = relocateData.$slotRefNode$;
        if (slotRefNode) {
          const parentNodeRef = slotRefNode.parentNode;
          let insertBeforeNode = slotRefNode.nextSibling;
          {
            let orgLocationNode = (_a = nodeToRelocate["s-ol"]) == null ? void 0 : _a.previousSibling;
            while (orgLocationNode) {
              let refNode = (_b = orgLocationNode["s-nr"]) != null ? _b : null;
              if (refNode && refNode["s-sn"] === nodeToRelocate["s-sn"] && parentNodeRef === (refNode.__parentNode || refNode.parentNode)) {
                refNode = refNode.nextSibling;
                while (refNode === nodeToRelocate || (refNode == null ? void 0 : refNode["s-sr"])) {
                  refNode = refNode == null ? void 0 : refNode.nextSibling;
                }
                if (!refNode || !refNode["s-nr"]) {
                  insertBeforeNode = refNode;
                  break;
                }
              }
              orgLocationNode = orgLocationNode.previousSibling;
            }
          }
          const parent = nodeToRelocate.__parentNode || nodeToRelocate.parentNode;
          const nextSibling = nodeToRelocate.__nextSibling || nodeToRelocate.nextSibling;
          if (!insertBeforeNode && parentNodeRef !== parent || nextSibling !== insertBeforeNode) {
            if (nodeToRelocate !== insertBeforeNode) {
              if (!nodeToRelocate["s-hn"] && nodeToRelocate["s-ol"]) {
                nodeToRelocate["s-hn"] = nodeToRelocate["s-ol"].parentNode.nodeName;
              }
              insertBefore(parentNodeRef, nodeToRelocate, insertBeforeNode);
              if (nodeToRelocate.nodeType === 1 /* ElementNode */ && nodeToRelocate.tagName !== "SLOT-FB") {
                nodeToRelocate.hidden = (_c = nodeToRelocate["s-ih"]) != null ? _c : false;
              }
            }
          }
          nodeToRelocate && typeof slotRefNode["s-rf"] === "function" && slotRefNode["s-rf"](slotRefNode);
        } else {
          if (nodeToRelocate.nodeType === 1 /* ElementNode */) {
            if (isInitialLoad) {
              nodeToRelocate["s-ih"] = (_d = nodeToRelocate.hidden) != null ? _d : false;
            }
            nodeToRelocate.hidden = true;
          }
        }
      }
    }
    if (checkSlotFallbackVisibility) {
      updateFallbackSlotVisibility(rootVnode.$elm$);
    }
    plt.$flags$ &= -2 /* isTmpDisconnected */;
    relocateNodes.length = 0;
  }
  contentRef = void 0;
};

// src/runtime/update-component.ts
var attachToAncestor = (hostRef, ancestorComponent) => {
  if (ancestorComponent && !hostRef.$onRenderResolve$ && ancestorComponent["s-p"]) {
    const index = ancestorComponent["s-p"].push(
      new Promise(
        (r) => hostRef.$onRenderResolve$ = () => {
          ancestorComponent["s-p"].splice(index - 1, 1);
          r();
        }
      )
    );
  }
};
var scheduleUpdate = (hostRef, isInitialLoad) => {
  {
    hostRef.$flags$ |= 16 /* isQueuedForUpdate */;
  }
  if (hostRef.$flags$ & 4 /* isWaitingForChildren */) {
    hostRef.$flags$ |= 512 /* needsRerender */;
    return;
  }
  attachToAncestor(hostRef, hostRef.$ancestorComponent$);
  const dispatch = () => dispatchHooks(hostRef, isInitialLoad);
  if (isInitialLoad) {
    queueMicrotask(() => {
      dispatch();
    });
    return;
  }
  return writeTask(dispatch) ;
};
var dispatchHooks = (hostRef, isInitialLoad) => {
  const elm = hostRef.$hostElement$;
  const endSchedule = createTime("scheduleUpdate", hostRef.$cmpMeta$.$tagName$);
  const instance = hostRef.$lazyInstance$ ;
  if (!instance) {
    throw new Error(
      `Can't render component <${elm.tagName.toLowerCase()} /> with invalid Stencil runtime! Make sure this imported component is compiled with a \`externalRuntime: true\` flag. For more information, please refer to https://stenciljs.com/docs/custom-elements#externalruntime`
    );
  }
  let maybePromise;
  if (isInitialLoad) {
    {
      {
        hostRef.$flags$ |= 256 /* isListenReady */;
        if (hostRef.$queuedListeners$) {
          hostRef.$queuedListeners$.map(([methodName, event]) => safeCall(instance, methodName, event, elm));
          hostRef.$queuedListeners$ = void 0;
        }
      }
      if (hostRef.$fetchedCbList$.length) {
        hostRef.$fetchedCbList$.forEach((cb) => cb(elm));
      }
    }
    maybePromise = safeCall(instance, "componentWillLoad", void 0, elm);
  } else {
    maybePromise = safeCall(instance, "componentWillUpdate", void 0, elm);
  }
  maybePromise = enqueue(maybePromise, () => safeCall(instance, "componentWillRender", void 0, elm));
  endSchedule();
  return enqueue(maybePromise, () => updateComponent(hostRef, instance, isInitialLoad));
};
var enqueue = (maybePromise, fn) => isPromisey(maybePromise) ? maybePromise.then(fn).catch((err2) => {
  console.error(err2);
  fn();
}) : fn();
var isPromisey = (maybePromise) => maybePromise instanceof Promise || maybePromise && maybePromise.then && typeof maybePromise.then === "function";
var updateComponent = async (hostRef, instance, isInitialLoad) => {
  var _a;
  const elm = hostRef.$hostElement$;
  const endUpdate = createTime("update", hostRef.$cmpMeta$.$tagName$);
  const rc = elm["s-rc"];
  if (isInitialLoad) {
    attachStyles(hostRef);
  }
  const endRender = createTime("render", hostRef.$cmpMeta$.$tagName$);
  {
    callRender(hostRef, instance, elm, isInitialLoad);
  }
  if (rc) {
    rc.map((cb) => cb());
    elm["s-rc"] = void 0;
  }
  endRender();
  endUpdate();
  {
    const childrenPromises = (_a = elm["s-p"]) != null ? _a : [];
    const postUpdate = () => postUpdateComponent(hostRef);
    if (childrenPromises.length === 0) {
      postUpdate();
    } else {
      Promise.all(childrenPromises).then(postUpdate);
      hostRef.$flags$ |= 4 /* isWaitingForChildren */;
      childrenPromises.length = 0;
    }
  }
};
var renderingRef = null;
var callRender = (hostRef, instance, elm, isInitialLoad) => {
  try {
    renderingRef = instance;
    instance = instance.render() ;
    {
      hostRef.$flags$ &= -17 /* isQueuedForUpdate */;
    }
    {
      hostRef.$flags$ |= 2 /* hasRendered */;
    }
    {
      {
        {
          renderVdom(hostRef, instance, isInitialLoad);
        }
      }
    }
  } catch (e) {
    consoleError(e, hostRef.$hostElement$);
  }
  renderingRef = null;
  return null;
};
var getRenderingRef = () => renderingRef;
var postUpdateComponent = (hostRef) => {
  const tagName = hostRef.$cmpMeta$.$tagName$;
  const elm = hostRef.$hostElement$;
  const endPostUpdate = createTime("postUpdate", tagName);
  const instance = hostRef.$lazyInstance$ ;
  const ancestorComponent = hostRef.$ancestorComponent$;
  safeCall(instance, "componentDidRender", void 0, elm);
  if (!(hostRef.$flags$ & 64 /* hasLoadedComponent */)) {
    hostRef.$flags$ |= 64 /* hasLoadedComponent */;
    {
      addHydratedFlag(elm);
    }
    safeCall(instance, "componentDidLoad", void 0, elm);
    endPostUpdate();
    {
      hostRef.$onReadyResolve$(elm);
      if (!ancestorComponent) {
        appDidLoad();
      }
    }
  } else {
    safeCall(instance, "componentDidUpdate", void 0, elm);
    endPostUpdate();
  }
  {
    hostRef.$onInstanceResolve$(elm);
  }
  {
    if (hostRef.$onRenderResolve$) {
      hostRef.$onRenderResolve$();
      hostRef.$onRenderResolve$ = void 0;
    }
    if (hostRef.$flags$ & 512 /* needsRerender */) {
      nextTick(() => scheduleUpdate(hostRef, false));
    }
    hostRef.$flags$ &= -517;
  }
};
var forceUpdate = (ref) => {
  var _a;
  {
    const hostRef = getHostRef(ref);
    const isConnected = (_a = hostRef == null ? void 0 : hostRef.$hostElement$) == null ? void 0 : _a.isConnected;
    if (isConnected && (hostRef.$flags$ & (2 /* hasRendered */ | 16 /* isQueuedForUpdate */)) === 2 /* hasRendered */) {
      scheduleUpdate(hostRef, false);
    }
    return isConnected;
  }
};
var appDidLoad = (who) => {
  nextTick(() => emitEvent(win, "appload", { detail: { namespace: NAMESPACE } }));
};
var safeCall = (instance, method, arg, elm) => {
  if (instance && instance[method]) {
    try {
      return instance[method](arg);
    } catch (e) {
      consoleError(e, elm);
    }
  }
  return void 0;
};
var addHydratedFlag = (elm) => {
  var _a;
  return elm.classList.add((_a = BUILD.hydratedSelectorName) != null ? _a : "hydrated") ;
};

// src/runtime/set-value.ts
var getValue = (ref, propName) => getHostRef(ref).$instanceValues$.get(propName);
var setValue = (ref, propName, newVal, cmpMeta) => {
  const hostRef = getHostRef(ref);
  if (!hostRef) {
    return;
  }
  if (!hostRef) {
    throw new Error(
      `Couldn't find host element for "${cmpMeta.$tagName$}" as it is unknown to this Stencil runtime. This usually happens when integrating a 3rd party Stencil component with another Stencil component or application. Please reach out to the maintainers of the 3rd party Stencil component or report this on the Stencil Discord server (https://chat.stenciljs.com) or comment on this similar [GitHub issue](https://github.com/stenciljs/core/issues/5457).`
    );
  }
  const elm = hostRef.$hostElement$ ;
  const oldVal = hostRef.$instanceValues$.get(propName);
  const flags = hostRef.$flags$;
  const instance = hostRef.$lazyInstance$ ;
  newVal = parsePropertyValue(
    newVal,
    cmpMeta.$members$[propName][0]);
  const areBothNaN = Number.isNaN(oldVal) && Number.isNaN(newVal);
  const didValueChange = newVal !== oldVal && !areBothNaN;
  if ((!(flags & 8 /* isConstructingInstance */) || oldVal === void 0) && didValueChange) {
    hostRef.$instanceValues$.set(propName, newVal);
    if (instance) {
      if (cmpMeta.$watchers$ && flags & 128 /* isWatchReady */) {
        const watchMethods = cmpMeta.$watchers$[propName];
        if (watchMethods) {
          watchMethods.map((watchMethodName) => {
            try {
              instance[watchMethodName](newVal, oldVal, propName);
            } catch (e) {
              consoleError(e, elm);
            }
          });
        }
      }
      if ((flags & (2 /* hasRendered */ | 16 /* isQueuedForUpdate */)) === 2 /* hasRendered */) {
        if (instance.componentShouldUpdate) {
          if (instance.componentShouldUpdate(newVal, oldVal, propName) === false) {
            return;
          }
        }
        scheduleUpdate(hostRef, false);
      }
    }
  }
};

// src/runtime/proxy-component.ts
var proxyComponent = (Cstr, cmpMeta, flags) => {
  var _a, _b;
  const prototype = Cstr.prototype;
  if (cmpMeta.$members$ || BUILD.propChangeCallback) {
    {
      if (Cstr.watchers && !cmpMeta.$watchers$) {
        cmpMeta.$watchers$ = Cstr.watchers;
      }
      if (Cstr.deserializers && !cmpMeta.$deserializers$) {
        cmpMeta.$deserializers$ = Cstr.deserializers;
      }
      if (Cstr.serializers && !cmpMeta.$serializers$) {
        cmpMeta.$serializers$ = Cstr.serializers;
      }
    }
    const members = Object.entries((_a = cmpMeta.$members$) != null ? _a : {});
    members.map(([memberName, [memberFlags]]) => {
      if ((memberFlags & 31 /* Prop */ || (flags & 2 /* proxyState */) && memberFlags & 32 /* State */)) {
        const { get: origGetter, set: origSetter } = Object.getOwnPropertyDescriptor(prototype, memberName) || {};
        if (origGetter) cmpMeta.$members$[memberName][0] |= 2048 /* Getter */;
        if (origSetter) cmpMeta.$members$[memberName][0] |= 4096 /* Setter */;
        if (flags & 1 /* isElementConstructor */ || !origGetter) {
          Object.defineProperty(prototype, memberName, {
            get() {
              {
                if ((cmpMeta.$members$[memberName][0] & 2048 /* Getter */) === 0) {
                  return getValue(this, memberName);
                }
                const ref = getHostRef(this);
                const instance = ref ? ref.$lazyInstance$ : prototype;
                if (!instance) return;
                return instance[memberName];
              }
            },
            configurable: true,
            enumerable: true
          });
        }
        Object.defineProperty(prototype, memberName, {
          set(newValue) {
            const ref = getHostRef(this);
            if (!ref) {
              return;
            }
            if (origSetter) {
              const currentValue = memberFlags & 32 /* State */ ? this[memberName] : ref.$hostElement$[memberName];
              if (typeof currentValue === "undefined" && ref.$instanceValues$.get(memberName)) {
                newValue = ref.$instanceValues$.get(memberName);
              }
              origSetter.apply(this, [
                parsePropertyValue(
                  newValue,
                  memberFlags)
              ]);
              newValue = memberFlags & 32 /* State */ ? this[memberName] : ref.$hostElement$[memberName];
              setValue(this, memberName, newValue, cmpMeta);
              return;
            }
            {
              if ((flags & 1 /* isElementConstructor */) === 0 || (cmpMeta.$members$[memberName][0] & 4096 /* Setter */) === 0) {
                setValue(this, memberName, newValue, cmpMeta);
                if (flags & 1 /* isElementConstructor */ && !ref.$lazyInstance$) {
                  ref.$fetchedCbList$.push(() => {
                    if (cmpMeta.$members$[memberName][0] & 4096 /* Setter */ && ref.$lazyInstance$[memberName] !== ref.$instanceValues$.get(memberName)) {
                      ref.$lazyInstance$[memberName] = newValue;
                    }
                  });
                }
                return;
              }
              const setterSetVal = () => {
                const currentValue = ref.$lazyInstance$[memberName];
                if (!ref.$instanceValues$.get(memberName) && currentValue) {
                  ref.$instanceValues$.set(memberName, currentValue);
                }
                ref.$lazyInstance$[memberName] = parsePropertyValue(
                  newValue,
                  memberFlags);
                setValue(this, memberName, ref.$lazyInstance$[memberName], cmpMeta);
              };
              if (ref.$lazyInstance$) {
                setterSetVal();
              } else {
                ref.$fetchedCbList$.push(() => {
                  setterSetVal();
                });
              }
            }
          }
        });
      } else if (flags & 1 /* isElementConstructor */ && memberFlags & 64 /* Method */) {
        Object.defineProperty(prototype, memberName, {
          value(...args) {
            var _a2;
            const ref = getHostRef(this);
            return (_a2 = ref == null ? void 0 : ref.$onInstancePromise$) == null ? void 0 : _a2.then(() => {
              var _a3;
              return (_a3 = ref.$lazyInstance$) == null ? void 0 : _a3[memberName](...args);
            });
          }
        });
      }
    });
    if ((flags & 1 /* isElementConstructor */)) {
      const attrNameToPropName = /* @__PURE__ */ new Map();
      prototype.attributeChangedCallback = function(attrName, oldValue, newValue) {
        plt.jmp(() => {
          var _a2;
          const propName = attrNameToPropName.get(attrName);
          const hostRef = getHostRef(this);
          if (this.hasOwnProperty(propName) && BUILD.lazyLoad) {
            newValue = this[propName];
            delete this[propName];
          }
          if (prototype.hasOwnProperty(propName) && typeof this[propName] === "number" && // cast type to number to avoid TS compiler issues
          this[propName] == newValue) {
            return;
          } else if (propName == null) {
            const flags2 = hostRef == null ? void 0 : hostRef.$flags$;
            if (hostRef && flags2 && !(flags2 & 8 /* isConstructingInstance */) && flags2 & 128 /* isWatchReady */ && newValue !== oldValue) {
              const instance = hostRef.$lazyInstance$ ;
              const entry = (_a2 = cmpMeta.$watchers$) == null ? void 0 : _a2[attrName];
              entry == null ? void 0 : entry.forEach((callbackName) => {
                if (instance[callbackName] != null) {
                  instance[callbackName].call(instance, newValue, oldValue, attrName);
                }
              });
            }
            return;
          }
          const propDesc = Object.getOwnPropertyDescriptor(prototype, propName);
          newValue = newValue === null && typeof this[propName] === "boolean" ? false : newValue;
          if (newValue != this[propName] && (!propDesc.get || !!propDesc.set)) {
            this[propName] = newValue;
          }
        });
      };
      Cstr.observedAttributes = Array.from(
        /* @__PURE__ */ new Set([
          ...Object.keys((_b = cmpMeta.$watchers$) != null ? _b : {}),
          ...members.filter(([_, m]) => m[0] & 31 /* HasAttribute */).map(([propName, m]) => {
            var _a2;
            const attrName = m[1] || propName;
            attrNameToPropName.set(attrName, propName);
            if (m[0] & 512 /* ReflectAttr */) {
              (_a2 = cmpMeta.$attrsToReflect$) == null ? void 0 : _a2.push([propName, attrName]);
            }
            return attrName;
          })
        ])
      );
    }
  }
  return Cstr;
};

// src/runtime/initialize-component.ts
var initializeComponent = async (elm, hostRef, cmpMeta, hmrVersionId) => {
  let Cstr;
  if ((hostRef.$flags$ & 32 /* hasInitializedComponent */) === 0) {
    hostRef.$flags$ |= 32 /* hasInitializedComponent */;
    const bundleId = cmpMeta.$lazyBundleId$;
    if (bundleId) {
      const CstrImport = loadModule(cmpMeta, hostRef);
      if (CstrImport && "then" in CstrImport) {
        const endLoad = uniqueTime();
        Cstr = await CstrImport;
        endLoad();
      } else {
        Cstr = CstrImport;
      }
      if (!Cstr) {
        throw new Error(`Constructor for "${cmpMeta.$tagName$}#${hostRef.$modeName$}" was not found`);
      }
      if (!Cstr.isProxied) {
        {
          cmpMeta.$watchers$ = Cstr.watchers;
          cmpMeta.$serializers$ = Cstr.serializers;
          cmpMeta.$deserializers$ = Cstr.deserializers;
        }
        proxyComponent(Cstr, cmpMeta, 2 /* proxyState */);
        Cstr.isProxied = true;
      }
      const endNewInstance = createTime("createInstance", cmpMeta.$tagName$);
      {
        hostRef.$flags$ |= 8 /* isConstructingInstance */;
      }
      try {
        new Cstr(hostRef);
      } catch (e) {
        consoleError(e, elm);
      }
      {
        hostRef.$flags$ &= -9 /* isConstructingInstance */;
      }
      {
        hostRef.$flags$ |= 128 /* isWatchReady */;
      }
      endNewInstance();
      fireConnectedCallback(hostRef.$lazyInstance$, elm);
    } else {
      Cstr = elm.constructor;
      const cmpTag = elm.localName;
      customElements.whenDefined(cmpTag).then(() => hostRef.$flags$ |= 128 /* isWatchReady */);
    }
    if (Cstr && Cstr.style) {
      let style;
      if (typeof Cstr.style === "string") {
        style = Cstr.style;
      }
      const scopeId2 = getScopeId(cmpMeta);
      if (!styles.has(scopeId2)) {
        const endRegisterStyles = createTime("registerStyles", cmpMeta.$tagName$);
        registerStyle(scopeId2, style, !!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */));
        endRegisterStyles();
      }
    }
  }
  const ancestorComponent = hostRef.$ancestorComponent$;
  const schedule = () => scheduleUpdate(hostRef, true);
  if (ancestorComponent && ancestorComponent["s-rc"]) {
    ancestorComponent["s-rc"].push(schedule);
  } else {
    schedule();
  }
};
var fireConnectedCallback = (instance, elm) => {
  {
    safeCall(instance, "connectedCallback", void 0, elm);
  }
};

// src/runtime/connected-callback.ts
var connectedCallback = (elm) => {
  if ((plt.$flags$ & 1 /* isTmpDisconnected */) === 0) {
    const hostRef = getHostRef(elm);
    if (!hostRef) {
      return;
    }
    const cmpMeta = hostRef.$cmpMeta$;
    const endConnected = createTime("connectedCallback", cmpMeta.$tagName$);
    if (!(hostRef.$flags$ & 1 /* hasConnected */)) {
      hostRef.$flags$ |= 1 /* hasConnected */;
      {
        if (// TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
        cmpMeta.$flags$ & (4 /* hasSlotRelocation */ | 8 /* needsShadowDomShim */)) {
          setContentReference(elm);
        }
      }
      {
        let ancestorComponent = elm;
        while (ancestorComponent = ancestorComponent.parentNode || ancestorComponent.host) {
          if (ancestorComponent["s-p"]) {
            attachToAncestor(hostRef, hostRef.$ancestorComponent$ = ancestorComponent);
            break;
          }
        }
      }
      if (cmpMeta.$members$) {
        Object.entries(cmpMeta.$members$).map(([memberName, [memberFlags]]) => {
          if (memberFlags & 31 /* Prop */ && memberName in elm && elm[memberName] !== Object.prototype[memberName]) {
            const value = elm[memberName];
            delete elm[memberName];
            elm[memberName] = value;
          }
        });
      }
      {
        initializeComponent(elm, hostRef, cmpMeta);
      }
    } else {
      addHostEventListeners(elm, hostRef, cmpMeta.$listeners$);
      if (hostRef == null ? void 0 : hostRef.$lazyInstance$) {
        fireConnectedCallback(hostRef.$lazyInstance$, elm);
      } else if (hostRef == null ? void 0 : hostRef.$onReadyPromise$) {
        hostRef.$onReadyPromise$.then(() => fireConnectedCallback(hostRef.$lazyInstance$, elm));
      }
    }
    endConnected();
  }
};
var setContentReference = (elm) => {
  if (!win.document) {
    return;
  }
  const contentRefElm = elm["s-cr"] = win.document.createComment(
    ""
  );
  contentRefElm["s-cn"] = true;
  insertBefore(elm, contentRefElm, elm.firstChild);
};
var disconnectInstance = (instance, elm) => {
  {
    safeCall(instance, "disconnectedCallback", void 0, elm || instance);
  }
};
var disconnectedCallback = async (elm) => {
  if ((plt.$flags$ & 1 /* isTmpDisconnected */) === 0) {
    const hostRef = getHostRef(elm);
    {
      if (hostRef == null ? void 0 : hostRef.$rmListeners$) {
        hostRef.$rmListeners$.map((rmListener) => rmListener());
        hostRef.$rmListeners$ = void 0;
      }
    }
    if (hostRef == null ? void 0 : hostRef.$lazyInstance$) {
      disconnectInstance(hostRef.$lazyInstance$, elm);
    } else if (hostRef == null ? void 0 : hostRef.$onReadyPromise$) {
      hostRef.$onReadyPromise$.then(() => disconnectInstance(hostRef.$lazyInstance$, elm));
    }
  }
  if (rootAppliedStyles.has(elm)) {
    rootAppliedStyles.delete(elm);
  }
  if (elm.shadowRoot && rootAppliedStyles.has(elm.shadowRoot)) {
    rootAppliedStyles.delete(elm.shadowRoot);
  }
};

// src/runtime/bootstrap-lazy.ts
var bootstrapLazy = (lazyBundles, options = {}) => {
  var _a;
  if (!win.document) {
    console.warn("Stencil: No document found. Skipping bootstrapping lazy components.");
    return;
  }
  const endBootstrap = createTime();
  const cmpTags = [];
  const exclude = options.exclude || [];
  const customElements2 = win.customElements;
  const head = win.document.head;
  const metaCharset = /* @__PURE__ */ head.querySelector("meta[charset]");
  const dataStyles = /* @__PURE__ */ win.document.createElement("style");
  const deferredConnectedCallbacks = [];
  let appLoadFallback;
  let isBootstrapping = true;
  Object.assign(plt, options);
  plt.$resourcesUrl$ = new URL(options.resourcesUrl || "./", win.document.baseURI).href;
  let hasSlotRelocation = false;
  lazyBundles.map((lazyBundle) => {
    lazyBundle[1].map((compactMeta) => {
      var _a2, _b, _c;
      const cmpMeta = {
        $flags$: compactMeta[0],
        $tagName$: compactMeta[1],
        $members$: compactMeta[2],
        $listeners$: compactMeta[3]
      };
      if (cmpMeta.$flags$ & 4 /* hasSlotRelocation */) {
        hasSlotRelocation = true;
      }
      {
        cmpMeta.$members$ = compactMeta[2];
      }
      {
        cmpMeta.$listeners$ = compactMeta[3];
      }
      {
        cmpMeta.$attrsToReflect$ = [];
      }
      {
        cmpMeta.$watchers$ = (_a2 = compactMeta[4]) != null ? _a2 : {};
        cmpMeta.$serializers$ = (_b = compactMeta[5]) != null ? _b : {};
        cmpMeta.$deserializers$ = (_c = compactMeta[6]) != null ? _c : {};
      }
      const tagName = cmpMeta.$tagName$;
      const HostElement = class extends HTMLElement {
        // StencilLazyHost
        constructor(self) {
          super(self);
          this.hasRegisteredEventListeners = false;
          self = this;
          registerHost(self, cmpMeta);
          if (cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */) {
            {
              if (!self.shadowRoot) {
                createShadowRoot.call(self, cmpMeta);
              } else {
                if (self.shadowRoot.mode !== "open") {
                  throw new Error(
                    `Unable to re-use existing shadow root for ${cmpMeta.$tagName$}! Mode is set to ${self.shadowRoot.mode} but Stencil only supports open shadow roots.`
                  );
                }
              }
            }
          }
        }
        connectedCallback() {
          const hostRef = getHostRef(this);
          if (!hostRef) {
            return;
          }
          if (!this.hasRegisteredEventListeners) {
            this.hasRegisteredEventListeners = true;
            addHostEventListeners(this, hostRef, cmpMeta.$listeners$);
          }
          if (appLoadFallback) {
            clearTimeout(appLoadFallback);
            appLoadFallback = null;
          }
          if (isBootstrapping) {
            deferredConnectedCallbacks.push(this);
          } else {
            plt.jmp(() => connectedCallback(this));
          }
        }
        disconnectedCallback() {
          plt.jmp(() => disconnectedCallback(this));
          plt.raf(() => {
            var _a3;
            const hostRef = getHostRef(this);
            if (!hostRef) {
              return;
            }
            const i2 = deferredConnectedCallbacks.findIndex((host) => host === this);
            if (i2 > -1) {
              deferredConnectedCallbacks.splice(i2, 1);
            }
            if (((_a3 = hostRef == null ? void 0 : hostRef.$vnode$) == null ? void 0 : _a3.$elm$) instanceof Node && !hostRef.$vnode$.$elm$.isConnected) {
              delete hostRef.$vnode$.$elm$;
            }
          });
        }
        componentOnReady() {
          var _a3;
          return (_a3 = getHostRef(this)) == null ? void 0 : _a3.$onReadyPromise$;
        }
      };
      cmpMeta.$lazyBundleId$ = lazyBundle[0];
      if (!exclude.includes(tagName) && !customElements2.get(tagName)) {
        cmpTags.push(tagName);
        customElements2.define(
          tagName,
          proxyComponent(HostElement, cmpMeta, 1 /* isElementConstructor */)
        );
      }
    });
  });
  if (cmpTags.length > 0) {
    if (hasSlotRelocation) {
      dataStyles.textContent += SLOT_FB_CSS;
    }
    {
      dataStyles.textContent += cmpTags.sort() + HYDRATED_CSS;
    }
    if (dataStyles.innerHTML.length) {
      dataStyles.setAttribute("data-styles", "");
      const nonce = (_a = plt.$nonce$) != null ? _a : queryNonceMetaTagContent(win.document);
      if (nonce != null) {
        dataStyles.setAttribute("nonce", nonce);
      }
      head.insertBefore(dataStyles, metaCharset ? metaCharset.nextSibling : head.firstChild);
    }
  }
  isBootstrapping = false;
  if (deferredConnectedCallbacks.length) {
    deferredConnectedCallbacks.map((host) => host.connectedCallback());
  } else {
    {
      plt.jmp(() => appLoadFallback = setTimeout(appDidLoad, 30));
    }
  }
  endBootstrap();
};

// src/runtime/fragment.ts
var Fragment = (_, children) => children;
var addHostEventListeners = (elm, hostRef, listeners, attachParentListeners) => {
  if (listeners && win.document) {
    listeners.map(([flags, name, method]) => {
      const target = getHostListenerTarget(win.document, elm, flags) ;
      const handler = hostListenerProxy(hostRef, method);
      const opts = hostListenerOpts(flags);
      plt.ael(target, name, handler, opts);
      (hostRef.$rmListeners$ = hostRef.$rmListeners$ || []).push(() => plt.rel(target, name, handler, opts));
    });
  }
};
var hostListenerProxy = (hostRef, methodName) => (ev) => {
  var _a;
  try {
    {
      if (hostRef.$flags$ & 256 /* isListenReady */) {
        (_a = hostRef.$lazyInstance$) == null ? void 0 : _a[methodName](ev);
      } else {
        (hostRef.$queuedListeners$ = hostRef.$queuedListeners$ || []).push([methodName, ev]);
      }
    }
  } catch (e) {
    consoleError(e, hostRef.$hostElement$);
  }
};
var getHostListenerTarget = (doc, elm, flags) => {
  if (flags & 4 /* TargetDocument */) {
    return doc;
  }
  if (flags & 8 /* TargetWindow */) {
    return win;
  }
  if (flags & 16 /* TargetBody */) {
    return doc.body;
  }
  return elm;
};
var hostListenerOpts = (flags) => supportsListenerOptions ? {
  passive: (flags & 1 /* Passive */) !== 0,
  capture: (flags & 2 /* Capture */) !== 0
} : (flags & 2 /* Capture */) !== 0;

// src/runtime/nonce.ts
var setNonce = (nonce) => plt.$nonce$ = nonce;

export { Fragment as F, Host as H, getElement as a, bootstrapLazy as b, createEvent as c, getRenderingRef as d, forceUpdate as f, globalScripts as g, h, promiseResolve as p, registerInstance as r, setNonce as s };
//# sourceMappingURL=index-BU3BT2jC.js.map

//# sourceMappingURL=index-BU3BT2jC.js.map